export default {
  es: {
    enlaces: {
      noticias: "/noticias",
      noticia: "/noticia",
      sala_de_prensa: "/sala-de-prensa",
      contacto: "/contacto",
      promociones: "/promociones",
      distribuidores: "/distribuidores",
      promocion: "/promocion",
      pressroom: "/pressroom",
      faqs: "/faqs",
      bases_legales: "/bases-legales",
      trabaja_con_nosotros: "/trabaja-con-nosotros",
      politica_privacidad: "/politica-de-proteccion-de-datos",
      politica_cookies: "/politica-de-cookies",
      aviso_legal: "/aviso-legal",
      ethical_chanel: "/canal-etico",
      snacks: "/snacks",
      galletas: "/galletas",
      caramelos: "/caramelos",
      historia: "/historia",
      nutririsi: "/nutririsi",
      risihoy: "/risi-hoy",
      codigoconducta: "/codigo-de-conducta",
      cartapresidente: "/codigo-de-conducta/carta-del-presidente",
      principiosgenerales: "/codigo-de-conducta/principios-generales",
      risiempleados: "/codigo-de-conducta/risi-y-sus-empleados",
      risiconsumidores: "/codigo-de-conducta/risi-y-sus-consumidores",
      risiproveedores: "/codigo-de-conducta/risi-y-sus-proveedores",
      risisociedad: "/codigo-de-conducta/risi-y-la-sociedad",
      daganzo: "/codigo-de-conducta/risi-y-la-sociedad/daganzo",
      loeches: "/codigo-de-conducta/risi-y-la-sociedad/loeches",
      matarile: "/codigo-de-conducta/risi-y-la-sociedad/matarile",
      cumplimientoetico:
        "/codigo-de-conducta/cumplimento-y-canal-de-comunicacion"
    },
    vistas: {
      productos: "Productos",
      snacks: "Snacks",
      galletas: "Galletas",
      caramelos: "Caramelos",
      promociones: "Promociones",
      sobre_risi: "Sobre Risi",
      historia: "Historia",
      risihoy: "Risi hoy",
      nutririsi: "Nutririsi",
      noticias_risi: "Noticias Risi",
      faqs: "Faqs",
      contacto: "Contacto",
      profesionales: "Profesionales",
      distribuidores: "Distribuidores",
      press_room: "Press Room",
      legal: "Legal",
      politica_cookies: "Política de Cookies",
      aviso_legal: "Aviso Legal",
      ethical_channel: "CANAL ÉTICO",
      proteccion_datos: "Protección de datos"
    },
    formulario: {
      nombre: "Nombre",
      apellidos: "Apellidos",
      email: "Email",
      mensaje: "Mensaje",
      asunto: "Asunto",
      medioComunicacion: "Medio de comunicación",
      he_leido: "He leído y acepto la",
      y_acepto: "política de privacidad",
      enviar: "Enviar",
      enviado: "Enviado",
      telefono: "Teléfono",
      provincia: "Provincia",
      localidad: "Localidad",
      cp: "Código postal"
    },
    meses: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    productos: {
      "gusanitos-tradicionales": {
        family: "gusanitos",
        type: "left",
        titulo: "Gusanitos Originales",
        packs: "18g, 35g, 70g, 85g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        intro:
          "<strong>¡Los auténticos Gusanitos!</strong> Los de toda la vida, los que gustan a niñ@s y a mayores.",
        introDos:
          " Snack horneado sin colorantes y sin conservantes.<br>¿Quién puede decir que no a una bolsa de Gusanitos? ",
        introMovil:
          "<strong>¡Los auténticos Gusanitos!</strong> Los de toda la vida, los que gustan a niñ@s y a mayores.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (17,4%), sal y aroma natural. <u>Puede contener proteína de leche</u>. Puede contener <u>mostaza</u>",
        cantidadValor: "100g",
        hashtag: "#GusanitoOriginal",
        energia: "1.965KJ, 467Kcal",
        hidratos: "71,1 g",
        azucares: "1 g",
        grasas: "17,4 g",
        saturadas: "2,2 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "6,6 g",
        mostrarSinLactosa: "1"
      },
      "gusanitos-ketchup": {
        family: "gusanitos",
        type: "left",
        titulo: "Gusanitos Kétchup",
        cantidadValor: "100g",
        hashtag: "#GusanitosKétchup",
        intro:
          "Un <strong>delicioso sabor kétchup</strong> invade a nuestros míticos Gusanitos, te encantarán.",
        introDos: " Sin conservantes y sin colorantes artificiales.",
        introMovil:
          "Un <strong>delicioso sabor kétchup</strong> invade a nuestros míticos Gusanitos, te encantarán.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (22%), aroma de kétchup [aroma, azúcar, potenciadores del sabor (E-621 y E-635), colorante (extracto de pimentón) y edulcorante (E951) *] y sal. <u>Puede contener proteína de leche</u>. *Contiene aspartamo (una fuente de fenilalanina).  Puede contener <u>mostaza</u>",
        packs: "35g 85g",
        energia: "2.065KJ, 492Kcal",
        hidratos: "67,7 g",
        azucares: "5,4 g",
        grasas: "22 g",
        saturadas: "2,8 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "5,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "palomitas-original": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Original",
        cantidadValor: "100g",
        hashtag: "#PalomitasOriginal",
        intro:
          "Las <strong>originales de toda la vida,</strong> nuestro sabor más clásico.",
        introDos:
          " <br>¡Imposible resistirse al sabor de la <strong>mantequilla</strong>!",
        introMovil:
          "Las <strong>originales de toda la vida,</strong> nuestro sabor más clásico.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (18,6 %), aroma de <u>mantequilla</u> [sustancias aromatizantes, <u>lactosa</u>, dextrosa, azúcar, suero <u>lácteo</u>, maltodextrina, almidón modificado y potenciador del sabor (E-621)] y sal.",
        packs: "35g, 75g, 90g",
        energia: "1.990KJ, 474Kcal",
        hidratos: "71 g",
        azucares: "1,5 g",
        grasas: "18,6 g",
        saturadas: "2,4 g",
        fibra: "",
        sal: "1,8 g",
        proteinas: "5,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "palomitas-ketchup-mostaza": {
        family: "palomitas",
        type: "right",
        titulo: "Palomitas Kétchup & Mostaza",
        cantidadValor: "100g",
        hashtag: "#PalomitasKétchup&Mostaza",
        intro:
          "¿Te atreves a mezclar? <strong>Las Palomitas más populares</strong>.",
        introDos: " <br>Con dos sabores que juntos hacen maravillas.",
        introMovil:
          "¿Te atreves a mezclar? <strong>Las Palomitas más populares</strong> ahora con dos sabores.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (17,1%), aroma de kétchup-<u>mostaza</u> [sustancias aromatizantes, maltodextrina, azúcar, dextrosa, potenciadores del sabor (E-621 y E-635), <u>mostaza</u>, colorantes (extracto de pimentón y E-100), acidulante (ácido cítrico), miel y edulcorante (E-951) *] y sal. Puede contener <u>proteína de leche.</u> * Contiene aspartamo (una fuente de fenilalanina).",
        packs: "35g, 75g, 90g",
        energia: "1.977KJ, 470Kcal",
        hidratos: "73 g",
        azucares: "2,9 g ",
        grasas: "17,1 g",
        saturadas: "2,1 g",
        fibra: "",
        sal: "2,1 g",
        proteinas: "6,1 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "palomitas-pizza": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Pizza",
        cantidadValor: "100g",
        hashtag: "#PalomitasPizza",
        intro:
          "Si eres fan de las pizzas y también lo eres de las míticas Palomitas, <br>¡Este es tu snack!",
        introDos: " Las Palomitas con <strong>sabor a Italia.</strong>",
        introMovil:
          "Si eres fan de las pizzas y también lo eres de las míticas Palomitas, <br>¡este es tu snack!",
        ingredientes:
          "Sémola de maíz aceite de girasol (22,7%), aroma de pizza [aroma, potenciadores de sabor (E-621 y E-635), colorante (extracto de pimentón) y azúcar] y sal. Contiene <u>leche y derivados</u>.",
        packs: "35g, 90g",
        energia: "1.882KJ, 450Kcal",
        hidratos: "55,5 g",
        azucares: "4,4 g",
        grasas: "22,7 g",
        saturadas: "2,7 g",
        fibra: "",
        sal: "1,8 g",
        proteinas: "5,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "palomitas-chocolate-blanco": {
        family: "palomitas",
        type: "right",
        titulo: "Palomitas Bombón Blanco",
        cantidadValor: "100g",
        hashtag: "#Palomitaschocoblanco",
        intro:
          "Para los que no pueden vivir sin el chocolate...nuestra versión de Palomitas recubiertas",
        introDos:
          " de <strong>delicioso Bombón Blanco.</strong><br>¡Una combinación de lo más especial!",
        introMovil:
          "Para los que no pueden vivir sin el chocolate...nuestra versión de Palomitas recubiertas.",
        ingredientes:
          "Azúcar, grasa de palmiste hidrogenada, sémola de maíz, suero de <u>leche</u> en polvo, <u>leche</u> desnatada en polvo, emulgente (lecitina de <u>soja</u>) y aromas (<u>leche</u>, y vainillina). <u>Puede contener frutos de cáscara (<u>almendra y avellana</u>)</u>.",
        packs: "30g, 120g",
        energia: "2.365KJ, 567Kcal",
        hidratos: "62,2 g",
        azucares: "46,0 g",
        grasas: "33,8 g",
        saturadas: "31,0 g",
        fibra: "",
        sal: "0,3 g",
        proteinas: "2,4 g",
        hasFrutosSecos: "1"
      },
      "palomitas-caramelo": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Caramelo",
        cantidadValor: "100g",
        hashtag: "#PalomitasCaramelo",
        intro:
          "¡Perfectas para los más golosos!… Nuestra edición de Palomitas más <strong>dulce</strong>.",
        introDos: " ¡Te encantarán!",
        introMovil:
          "¡Perfectas para los más golosos!… Nuestra edición de Palomitas más <strong>dulce</strong>.",
        ingredientes:
          "Azúcar, sémola de maíz, jarabe de glucosa, aceite de girasol (14.6%), mantequilla, lecitina de girasol, caramelo y sal. Contiene <u>leche y derivados</u>. Puede contener <u>frutos de cáscara (almendra y avellana) y soja</u>",
        packs: "30g, 110g",
        energia: "1.799KJ, 428Kcal",
        hidratos: "70,7 g",
        azucares: "47,6 g",
        grasas: "14,6 g",
        saturadas: "3,2 g",
        fibra: "",
        sal: "0,6 g",
        proteinas: "2,4 g",
        hasFrutosSecos: "1"
      },
      "palomitas-chocolate": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Choco",
        cantidadValor: "100g",
        hashtag: "#PalomitasChoco",
        intro:
          "Nuestra versión dulce recubierta de <strong>delicioso choco</strong>.",
        introDos: "",
        introMovil:
          "Nuestra versión dulce recubierta de <strong>delicioso chocolate</strong>.",
        ingredientes:
          "Azúcar, sémola de maíz, grasa de palma totalmente hidrogenada, cacao en polvo desgrasado (12%), emulgente (lecitina de <u>soja</u> y E-492) y aroma (vainillina). Puede contener <u>leche y frutos de cáscara (almendra y avellana)</u>.",
        packs: "30g, 120g",
        energia: "2.260KJ, 542Kcal",
        hidratos: "56,6 g",
        azucares: "41,4 g",
        grasas: "33,1 g",
        saturadas: "30,5 g",
        fibra: "",
        sal: "0,06 g",
        proteinas: "4,3 g",
        hasFrutosSecos: "1"
      },
      "palomitas-chocolate-avellana": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Choco Avellana",
        cantidadValor: "100g",
        hashtag: "#PalomitasChocoAvellana",
        intro:
          "Nuestra versión dulce recubierta de <strong>delicioso choco y avellana</strong>.",
        introDos: "",
        introMovil:
          "Nuestra versión dulce recubierta de <strong>delicioso choco y avellana</strong>.",
        ingredientes:
          "Azúcar, sémola de maíz, grasa vegetal (palmiste parcialmente hidrogenado refinado) de origen láurico, <u>lactosuero</u>, pasta de <u>avellana</u> (6 %), cacao en polvo desgrasado, emulgente (lecitina de <u>soja</u>) y aromas (vainillina y avellana).Contiene <u>leche</u> y <u>derivados</u>, <u>frutos de cáscara</u> y <u>soja</u>.",
        packs: "30g, 90g",
        energia: "2.283KJ, 684Kcal",
        hidratos: "58 g",
        azucares: "47,3 g",
        grasas: "32,5 g",
        saturadas: "28,3 g",
        fibra: "",
        sal: "0,2 g",
        proteinas: "4,3 g",
        hasFrutosSecos: "1"
      },
      "palomitas-bacon-cheese": {
        family: "palomitas",
        type: "left",
        titulo: "Palomitas Bacon & Cheese",
        cantidadValor: "100g",
        hashtag: "#PalomitasBacon&Cheese",
        intro: "Nuestra versión sabor <strong>bacon & cheese</strong>.",
        introDos: "",
        introMovil: "Nuestra versión sabor <strong>bacon & cheese</strong>.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (24,8%), aromas de bacon y <u>queso</u> [aroma, aroma de humo, colorantes (extracto de pimentón y curcumina)]. Contiene <u>leche y derivados</u>. Puede contener <u>mostaza</u>",
        packs: "30g, 90g",
        energia: "2.237KJ, 534Kcal",
        hidratos: "72 g",
        azucares: "2,9 g",
        grasas: "24,8 g",
        saturadas: "3 g",
        fibra: "",
        sal: "2,1 g",
        proteinas: "5,6 g",
        hasFrutosSecos: "0"
      },
      "mios-maiz-chia": {
        family: "mios",
        type: "left",
        titulo: "Chips de Maíz & Chía",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyChía",
        intro:
          "Aperitivo de maíz frito con uno de los superalimentos más queridos, la <strong>semillas de chía</strong> ",
        introDos:
          " y el toque especial de la <strong>sal marina.</strong><br>¡Con ingredientes naturales!",
        introMovil:
          "Aperitivo de maíz frito con uno de los superalimentos más queridos, la <strong>semillas de chía</strong>.",
        ingredientes:
          "Maíz (70%), aceite de girasol alto oleico (24 %), semillas de chía (3 %) y sal marina.",
        packs: "150g",
        energia: "2.154KJ, 515Kcal",
        hidratos: "64,4 g",
        azucares: "1,3 g",
        grasas: "24 g",
        saturadas: "2,4 g",
        fibra: "6,0 g",
        sal: "0,9 g",
        proteinas: "7,4 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-espinacas": {
        family: "mios",
        type: "right",
        titulo: "Chips de Maíz & Espinacas",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyEspinacas",
        intro:
          "¿Te atreves con un sabor de lo más exclusivo? Delicioso aperitivo de maíz frito.",
        introDos:
          " <strong>¡Con espinacas y pimienta rosa!</strong> Y… ¡Con ingredientes naturales!",
        introMovil:
          "¿Te atreves con un sabor de lo más exclusivo? Aperitivo de maíz frito<strong> con espinacas</strong>.",
        ingredientes:
          "Maíz (64 %), aceite de girasol alto oleico (28,2 %), espinaca deshidratada (2 %) y aroma de pimienta [sal marina, pimientas rosa, negra y blanca molidas (0,4 %), azúcar y aroma].",
        packs: "150g",
        energia: "2.257KJ, 540Kcal",
        hidratos: "61,1 g",
        azucares: "1,7 g",
        grasas: "28,2 g",
        saturadas: "2,8 g",
        fibra: "7,7 g",
        sal: "1,2 g",
        proteinas: "6,8 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "mios-maiz-cebolla": {
        family: "mios",
        type: "left",
        titulo: "Chips de Maíz & Cebolla",
        cantidadValor: "100g",
        hashtag: "#MiosMaízyCebolla",
        intro:
          "Un sabor <strong>delicioso y sofisticado</strong> que te hará disfrutar de un aperitivo lleno de sabor",
        introDos:
          " y como todas las variedades Mios... <br>¡Solo con ingredientes naturales!",
        introMovil:
          "Un sabor <strong>delicioso y sofisticado</strong> que te hará disfrutar de un aperitivo lleno de sabor.",
        ingredientes:
          "Maíz (65%), aceite de girasol alto oleico (26,5 %), cebolla deshidratada (3%), aroma de vinagre balsámico de Módena (0,02%) y cebolla.",
        packs: "150g",
        energia: "2.191KJ, 524Kcal",
        hidratos: " 61,9 g",
        azucares: "3,7 g",
        grasas: " 26,5 g",
        saturadas: "2,7 g",
        fibra: "6,0 g",
        sal: " 1,2 g",
        proteinas: " 6,5 g",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-queso": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Cheese",
        cantidadValor: "100g",
        hashtag: "#MatchBallCheese",
        intro:
          "Sabrosas bolitas con sabor a queso…mmm…<strong>¡Mucho queso!</strong>",
        introDos: "",
        introMovil:
          "Sabrosas bolitas con sabor a queso…mmm…<strong>¡Mucho queso!</strong>",
        ingredientes:
          "Sémola de maíz, aceite de girasol (20,9%), aroma de <u>queso</u> [aroma, maltodextrina, <u>lactosa</u>, <u>suero de leche</u>, potenciadores del sabor (E-621 y E-635) y acidulante (ácido cítrico)], azúcar y sal. Contiene <u>leche y derivados</u>.",
        packs: "30g, 105g",
        energia: "1.963KJ, 468Kcal",
        hidratos: "64,7 g",
        azucares: "8,2 g",
        grasas: "20,9 g",
        saturadas: "2,6 g",
        fibra: "",
        sal: "2,0 g",
        proteinas: "5,3 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "match-ball-ketchup": {
        family: "match-ball",
        type: "right",
        titulo: "MatchBall Kétchup",
        cantidadValor: "100g",
        hashtag: "#MatchBallKétchup",
        intro:
          "Si eres de los que adoras el Kétchup...estas son sin duda tus Match Ball.",
        introDos:
          " Las bolitas de siempre con <strong>sabor a Kétchup</strong>.",
        introMovil:
          "Si eres de los que adoras el Kétchup...estas son sin duda tus Match Ball.",
        ingredientes:
          "Sémola de maíz, aceite de girasol (20,2%), aroma de kétchup [aroma, potenciadores del sabor (E-621 y E-635), colorante (extracto de pimentón) y edulcorante (E951)*], azúcar y sal. Puede contener <u>proteína de leche</u>. *Contiene aspartamo (una fuente de fenilalanina).",
        packs: "30g, 105g",
        energia: "2044KJ, 487Kcal",
        hidratos: "70,6 g",
        azucares: "12,5 g",
        grasas: "20,2 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,0 g",
        proteinas: "5,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-barbacoa": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Barbacoa",
        cantidadValor: "100g",
        hashtag: "#MatchBallBarbacoa",
        intro:
          "¿Te declaras fan de las barbacoas y del <strong>sabor a barbacoa</strong>?",
        introDos:
          " <br>Estas Match Ball están pensadas solo para ti…¡Deliciosas!",
        introMovil:
          "¿Te declaras fan de las barbacoas y del <strong>sabor a barbacoa</strong>?",
        ingredientes:
          "Sémola de maíz, aceite de girasol (22,2%), aroma de salsa barbacoa [azúcar, sal, maltodextrina, almidón de maíz, dextrosa, extractos de levadura, aromas, cebolla en polvo, ajo en polvo, aromas de humo y colorante (extracto de pimentón)]. Puede contener <u>proteína de leche</u>.",
        packs: "30g, 105g",
        energia: "2057KJ, 491Kcal",
        hidratos: "68 g",
        azucares: "10,8 g",
        grasas: "22,2 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,3 g",
        proteinas: "4,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "match-ball-minis": {
        family: "match-ball",
        type: "left",
        titulo: "MatchBall Minis",
        cantidadValor: "100g",
        hashtag: "#MatchBallMinis",
        intro:
          "En tamaño mini pero con el sabor de las grandes y por supuesto con mucho queso.",
        introDos:
          " <br>¿Y lo mejor de todo? Que ahora con el nuevo formato van <strong>directas del pack a tu boca,</strong> ¿a qué mola?",
        introMovil:
          "En tamaño mini pero con el sabor de las grandes y por supuesto con mucho queso.",
        ingredientes:
          "Sémola de maíz, aceite de girasol, aroma de <u>queso</u> [sustancias aromatizantes, maltodextrina de patata, <u>lactosa</u>, suero <u>lácteo</u>, potenciadores del sabor (E-621, E-627 y E-631) y acidulante (ácido cítrico)] azúcar y sal.",
        packs: "27g",
        energia: "2.097KJ, 500Kcal",
        hidratos: "66,2 g",
        azucares: "11 g",
        grasas: "24 g",
        saturadas: "3,1 g",
        fibra: "",
        sal: " 1,6 g",
        proteinas: "4,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "risketos-original": {
        family: "risketos",
        type: "left",
        titulo: "Risketos Original",
        cantidadValor: "100g",
        hashtag: "#RisketosOriginal",
        intro:
          "Para los amantes de los auténticos Risketos, en su <strong>sabor original</strong>.",
        introDos: " Crujientes y con el característico sabor a queso.",
        introMovil:
          "Para los amantes de los auténticos Risketos, en su <strong>sabor original</strong>.",
        ingredientes:
          "Sémola de maíz, aceite de girasol alto oleico (26,5 %), aceite de girasol (9 %), aroma de <u>queso</u> [aroma y potenciador del sabor (E-621), colorante (extracto de pimentón)], sal y emulgente (E-471). Contiene <u>leche y derivados</u>.",
        packs: "40g, 80g, 100g, 120g",
        energia: "2.317KJ, 556Kcal",
        hidratos: "53,5 g",
        azucares: "2,3 g",
        grasas: "35,5 g",
        saturadas: "3,6 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "5,5 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "risketos-ketchup": {
        family: "risketos",
        type: "left",
        titulo: "Risketos Kétchup",
        cantidadValor: "100g",
        hashtag: "#RisketosKétchup",
        intro:
          "Si eres de los que a todo le echan <strong>kétchup,</strong> estos Risketos son para ti.",
        introDos: " Los mí­ticos Risketos ahora con un sabor delicioso.",
        introMovil:
          "Si eres de los que a todo le echan <strong>kétchup,</strong> estos Risketos son para ti.",
        ingredientes:
          "Sémola de maíz, aceite de girasol alto oleico (25.5%), aceite de girasol (9%), aroma de <u>queso</u> kétchup [aroma, azúcar, potenciadores del sabor (E-621 y E-635) y edulcorante (E-951)*], sal, emulgente (E-471) y colorante (extracto de pimentón). *Contiene aspartamo (una fuente de fenilalanina) Contiene <u>leche y derivados</u>.",
        packs: "40g, 120g",
        energia: "2.368KJ, 567Kcal",
        hidratos: "58,4 g",
        azucares: "2,9 g",
        grasas: "34,5 g",
        saturadas: "3,5",
        fibra: "",
        sal: "1,2 g",
        proteinas: "5,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "risketos-queso-picante": {
        family: "risketos",
        type: "left",
        titulo: "Risketos Queso Picante",
        cantidadValor: "100g",
        hashtag: "#RisketosQuesoPicante",
        intro:
          "Los Risketos para los más atrevidos. Con <strong>queso picante y un toque de chili</strong>.",
        introDos: " Igual de crunchy que todos pero con otra actitud.",
        introMovil:
          "Los Risketos para los más atrevidos. Con <strong>queso picante y un toque de chili</strong>.",
        ingredientes:
          "Sémola de maíz, aceite de girasol alto oleico (26,5 %), aceite de girasol (9 %), aroma de queso picante [dextrosa, suero de <u><strong>leche</u></strong> en polvo, sal, aroma, especias, regulador de acidez (E-270 y E-330) y colorante (extracto de pimentón)] y emulgente (E-471). Contiene <u>leche y derivados</u>.",
        packs: "40g, 120g",
        energia: "2.317KJ, 556Kcal",
        hidratos: "53,5 g",
        azucares: "2,3 g",
        grasas: "35,5 g",
        saturadas: "3,6 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "5,5 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "triskys-original": {
        family: "triskys",
        type: "left",
        titulo: "Triskys Original",
        cantidadValor: "100g",
        hashtag: "#TriskysOriginal",
        intro:
          "Tus Triskys de toda la vida, los auténticos aperitivos de maí­z, <strong>crujientes</strong>",
        introDos: " <strong>y redondos</strong> en su sabor original.",
        introMovil:
          "Tus Triskys de toda la vida, los auténticos aperitivos de maí­z <strong>crujientes</strong>.",
        ingredientes:
          "Sémola de maíz, aceite de girasol alto oleico (24,8 %), almidón de maíz, sal, gasificante (bicarbonato sódico), emulgente (E-471), acidulante (ácido cítrico) y corrector de acidez (E-526). Puede contener <u>proteína de leche</u>.",
        packs: "20g, 35g, 85g, 100g, 115g",
        energia: "2.223KJ, 530Kcal",
        hidratos: "71,1 g",
        azucares: "0,5 g",
        grasas: "24,8 g",
        saturadas: "2,5 g",
        fibra: "",
        sal: "2,8 g",
        proteinas: "5,7 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "triskys-jamon": {
        family: "triskys",
        type: "right",
        titulo: "Triskys Jamón",
        cantidadValor: "100g",
        hashtag: "#TriskysJamón",
        intro: "<strong>De pata negra y sabroso sabor</strong>,",
        introDos: " un toque único e ibérico que no te dejará indiferente",
        introMovil: "<strong>De pata negra y sabroso sabor</strong>.",
        ingredientes:
          "Sémola de maíz, aceite de girasol alto oleico (24,7 %), almidón de maíz, sal, aroma de jamón [aroma, aroma de humo, potenciador del sabor (E-621), colorante (extracto de pimentón)], gasificante (bicarbonato sódico), emulgente (E-471), acidulante (ácido cítrico), corrector de acidez (E-526). Contiene leche.",
        packs: "35g",
        energia: "2.101KJ, 502Kcal",
        hidratos: " 64,2g",
        azucares: "1,3 g",
        grasas: " 24,7g",
        saturadas: "2,5 g",
        fibra: "",
        sal: " 3,3g",
        proteinas: "5,6 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "triskys-barbacoa": {
        family: "triskys",
        type: "left",
        titulo: "Triskys Barbacoa",
        cantidadValor: "100g",
        hashtag: "#TriskysBarbacoa",
        intro: "La novedad de la casa, un sabor intenso llega a tus Triskys,",
        introDos:
          " <strong>el sabor de una auténtica y crujiente parrilla</strong>.",
        introMovil:
          " <strong>El sabor de una auténtica y crujiente parrilla</strong> llega a tus Triskys.",
        ingredientes:
          "Sémola de maíz, aceite de girasol alto oleico (20,3 %), almidón de maíz, sal, aroma de salsa barbacoa [aroma, potenciador del sabor (E-621) y colorante (extracto de pimentón)], gasificante (bicarbonato sódico), emulgente (E-471), acidulante (ácido cítrico) y corrector de acidez (E-526). Puede contener <u>proteína de leche</u>.",
        packs: "115g",
        energia: "1.964KJ, 468Kcal",
        hidratos: "65,7 g",
        azucares: "1,0 g",
        grasas: "20,3 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "3,8 g",
        proteinas: "4,5 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      buscalios: {
        family: "otros-productos",
        type: "left",
        titulo: "Buscalios",
        cantidadValor: "100g",
        hashtag: "#Buscalios",
        intro:
          "Deliciosas y crujientes fajitas de maí­z con intenso sabor a barbacoa,",
        introDos:
          " <br>así son los Buscalíos de Risi. <strong>¡Descubre el auténtico sabor del oeste!</strong>",
        introMovil:
          "Deliciosas y crujientes fajitas de maí­z con intenso sabor a barbacoa.",
        ingredientes:
          "Maíz, aceite de girasol alto oleico (23.1 %), aroma salsa barbacoa [aroma, aroma de humo, azúcar, sal, potenciadores del sabor (E-621 y E-635) y colorante (extracto de pimentón)]. Puede contener <u>proteína de leche</u>.",
        packs: "35g, 140g",
        energia: "2.173KJ, 519Kcal",
        hidratos: "67,3 g",
        azucares: "7,5 g",
        grasas: "23,1 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "5,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "clasicas-originales": {
        family: "otros-productos",
        type: "left",
        titulo: "Clásicas Originales",
        cantidadValor: "100g",
        hashtag: "#PatatasClásicasRisi",
        intro:
          "Nuestras patatas <strong>clásicas onduladas y con sal</strong>.",
        introDos: " <br>¡Las patatas más crujientes del mundo mundial!",
        introMovil:
          "Nuestras patatas <strong>clásicas onduladas y con sal</strong>.",
        ingredientes:
          "Patatas, aceite de girasol (34.8%) y sal. Puede contener <u>proteína de leche</u>.",
        packs: "30g, 50g, 100g",
        energia: "2.328KJ, 558Kcal",
        hidratos: "54,1 g",
        azucares: "1,0 g",
        grasas: "34,8 g",
        saturadas: "4,4 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "7,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-originales": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Originales",
        cantidadValor: "100g",
        hashtag: "#PatatasOnduladasRisi",
        intro:
          "Nuestras patatas clásicas onduladas <strong>crujientes y con sal</strong>.",
        introDos: " <br>¡Descubre todas nuestras variedades de sabor!",
        introMovil:
          "Nuestras patatas clásicas onduladas <strong>crujientes y con sal</strong>.",
        ingredientes:
          "Patatas, aceite de girasol (32.1 %) y sal. Puede contener <u>proteína de leche</u>.",
        packs: "30g, 50g, 100g",
        energia: "2.206KJ, 529Kcal",
        hidratos: "54,5 g",
        azucares: "0,8 g",
        grasas: "32,1 g",
        saturadas: "3,9 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "5,4 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-campesinas": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Campesinas",
        cantidadValor: "100g",
        hashtag: "#PatatasOnduladasCampesinas",
        intro:
          "Nuestras onduladas <strong>sabor campenisas</strong>, el sabor más campesino.",
        introDos: "",
        introMovil:
          "Nuestras onduladas <strong>sabor campenisas</strong>, el sabor más campesino.",
        ingredientes:
          "Patatas, aceite de girasol (34,5 %), aroma campesinas [aroma, aroma de humo, azúcar, sal (1,2 %), potenciadores del sabor (E-621 y E-635), colorante (extracto de pimentón) y tomate en polvo (0,1 %)]. Puede contener <u>proteína de leche</u>.",
        packs: "30g, 50g, 100g",
        energia: "2.28KJ, 549Kcal",
        hidratos: "53,5 g",
        azucares: "1,6 g",
        grasas: "34,5 g",
        saturadas: "4,3 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "6,0 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-jamon": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Jamón",
        cantidadValor: "100g",
        hashtag: "#PatatasOnduladasJamón",
        intro:
          "Nuestras onduladas <strong>sabor jamón</strong>, el sabor más serrano.",
        introDos: "",
        introMovil:
          "Nuestras onduladas <strong>sabor jamón</strong>, el sabor más serrano.",
        ingredientes:
          "Patatas, aceite de girasol (37.7 %), aroma jamón [aroma, aroma de humo, potenciadores del sabor (E-621 y E-635) y sal]. Puede contener <u>proteína de leche</u>.",
        packs: "30g, 50g, 100g",
        energia: "2.338KJ, 561Kcal",
        hidratos: "50,4 g",
        azucares: "1,6 g",
        grasas: "37,7 g",
        saturadas: "4,6 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "5,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "onduladas-cheese-onion": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Cheese & Onion",
        cantidadValor: "100g",
        hashtag: "#PatatasOnduladasCheeseOnion",
        intro: "Nuestra sabrosa versión con <strong>queso y cebolla</strong>.",
        introDos: "",
        introMovil:
          "Nuestra sabrosa versión con <strong>queso y cebolla</strong>.",
        ingredientes:
          "Patatas, aceite de girasol (35,2 %), aroma <u>queso</u> y cebolla [aroma, sal, azúcar y potenciadores del sabor (E-621 y E-635)]. Puede contener <u>proteína de leche</u>.",
        packs: "100g",
        energia: "2.285KJ, 548Kcal",
        hidratos: "51,6 g",
        azucares: "2,9 g",
        grasas: "35,2 g",
        saturadas: "4,2 g",
        fibra: "",
        sal: "1,1 g",
        proteinas: "6,2 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "onduladas-vinagreta": {
        family: "otros-productos",
        type: "left",
        titulo: "Onduladas Vinagreta",
        cantidadValor: "100g",
        hashtag: "#PatatasOnduladasVinagreta",
        intro:
          "No te pierdas un <strong>sabor único a vinagreta</strong> para tus patatas onduladas.",
        introDos: "",
        introMovil:
          "No te pierdas un <strong>sabor único a vinagreta</strong> para tus patatas onduladas.",
        ingredientes:
          "Patatas, aceite de girasol (33.6 %), aroma de vinagre y sal. Puede contener <u>proteína de leche.</u>",
        packs: "100g",
        energia: "2.188KJ, 525Kcal",
        hidratos: "51,7 g",
        azucares: "1,0 g",
        grasas: "33,6 g",
        saturadas: "4,0 g",
        fibra: "",
        sal: "1,4 g",
        proteinas: "3,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      toscana: {
        family: "otros-productos",
        type: "left",
        titulo: "Clásicas Toscana",
        cantidadValor: "100g",
        hashtag: "#PatatasClásicasToscana",
        intro: "Patatas fritas lisas <strong>sabor toscana</strong>.",
        introDos: "",
        introMovil: "Patatas fritas lisas <strong>sabor toscana</strong>.",
        ingredientes:
          "Patatas, aceite de girasol (34.8 %), aroma toscana [azúcar, sal, fibra de guisante, tomate en polvo (6 %), extractos levaduras, maltodextrina, aromas, cebolla en polvo (4,5 %), dextrosa, perejil (4 %), pimentón (3.5 %), ajo en polvo (2.5 %), ácido cítrico, colorante natural (oleorresina de pimentón)].",
        packs: "100g",
        energia: "2.095KJ, 502Kcal",
        hidratos: "53 g",
        azucares: "3,1 g",
        grasas: "27,6 g",
        saturadas: "3,2 g",
        fibra: "",
        sal: "1,2 g",
        proteinas: "6,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      tejitas: {
        family: "otros-productos",
        type: "left",
        titulo: "Tejitas",
        cantidadValor: "100g",
        hashtag: "#TejitasRisi",
        intro:
          "Las legendarias Tejitas, un <strong>sabor a queso</strong> que se desharán en tu boca.",
        introDos: "",
        introMovil:
          "Las legendarias Tejitas, un <strong>sabor a queso</strong> que se desharán en tu boca.",
        ingredientes:
          "Sémola de maíz, aceite de girasol, aroma de <u>queso</u> [sustancias aromatizantes, almidón hidrolizado, <u>lactosa</u>, azúcar, suero <u>lácteo</u>, potenciadores del sabor (E-621 y E-635), acidulante (ácido cítrico)] y sal. Puede contener <u>mostaza</u>.",
        packs: "35g, 100g",
        energia: "2.202KJ, 526Kcal",
        hidratos: "65,6 g",
        azucares: "4,1 g",
        grasas: "26,7 g",
        saturadas: "4,6 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "5,8 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "surtis-4u": {
        family: "otros-productos",
        type: "left",
        titulo: "Surtis 4U",
        cantidadValor: "100g",
        hashtag: "#Surtis4U",
        intro:
          "Nuestro mix más especial, disfruta de <strong>nuestros mejores productos en una sola bolsa</strong>.",
        introDos: "",
        introMovil:
          "Nuestro mix más especial, disfruta de <strong>nuestros mejores productos</strong>.",
        ingredientes:
          "Maíz, aceite de girasol (29,1 %), aromas de salsa barbacoa y <u>queso</u> [aroma, aroma de humo, potenciadores del sabor (E-621 y E-635)], azúcar, almidón de maíz, sal, gasificante (bicarbonato sódico), colorante (extracto de pimentón), emulgente (E-471), acidulante (ác. cítrico) y corrector de acidez (E-526). Contiene <u>leche y derivados</u>.",
        packs: "110g",
        energia: "2.209KJ, 528Kcal",
        hidratos: "60,6 g",
        azucares: "1,0 g",
        grasas: "29,1 g",
        saturadas: "2,9 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "6,0 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      "surtis-4u-mini": {
        family: "otros-productos",
        type: "left",
        titulo: "Surtis 4U Mini",
        cantidadValor: "100g",
        hashtag: "#Surtis4U Mini",
        intro:
          "Nuestro mix más especial, disfruta de nuestros mejores productos en una sola bolsa.",
        introDos:
          " <br>Ahora en un nuevo formato mini, <strong>¡del pack a tu boca!</strong>",
        introMovil:
          "Nuestro mix más especial, disfruta de <strong>nuestros mejores productos</strong>.",
        ingredientes:
          "Maíz, aceite de girasol (29,1 %), aromas de salsa barbacoa y <u>queso</u> [aroma, aroma de humo, potenciadores del sabor (E-621 y E-635)], azúcar, almidón de maíz, sal, gasificante (bicarbonato sódico), colorante (extracto de pimentón), emulgente (E-471), acidulante (ác. cítrico) y corrector de acidez (E-526). Contiene </u>leche y derivados</u>.",
        packs: "37g",
        energia: "2.209KJ, 528Kcal",
        hidratos: "60,6 g",
        azucares: "1,0 g",
        grasas: "29,1 g",
        saturadas: "2,9 g",
        fibra: "",
        sal: "1,9 g",
        proteinas: "6,0 g",
        hasGluten: "0",
        hasFrutosSecos: "0"
      },
      pajitas: {
        family: "otros-productos",
        type: "left",
        titulo: "Pajitas",
        cantidadValor: "100g",
        hashtag: "#PajitasdeRisi",
        intro: "Si piensas en algo crujiente y sabroso…¡No falla!",
        introDos:
          " <br>Te viene a la mente las inconfundibles Pajitas de Risi al punto de sal. <br><strong>¡Elige con o sin Kétchup!</strong>",
        introMovil: "Pajitas de Risi al punto de sal.",
        ingredientes:
          "Fécula de patata (49,3 %), patata deshidratada (13,1 %), aceite de girasol alto oleico (22,7 %), almidón modificado de patata (6,6 %), sal, aroma de patata [aroma y potenciadores del sabor (E-621 y E-635)] y emulgente (E-471). Puede contener <u>proteína de leche</u>.",
        packs: "20g, 100g",
        energia: "2.059KJ, 491Kcal",
        hidratos: "69,8 g",
        azucares: "1,2 g",
        grasas: "22,7 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,9 g",
        proteinas: "1,9 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "pajitas-ketchup": {
        family: "otros-productos",
        type: "left",
        titulo: "Pajitas Kétchup",
        cantidadValor: "100g",
        hashtag: "#PajitasDeKétchupRisi",
        intro: "Las mí­ticas y crujientes con <strong>sabor Kétchup</strong>.",
        introDos: "",
        introMovil:
          "Las mí­ticas y crujientes con <strong>sabor Kétchup</strong>.",
        ingredientes:
          "Fécula de patata (49,3 %), patata deshidratada (13,1 %), aceite de girasol alto oleico (22,7 %), almidón modificado de patata (6,6 %), sal, aroma de patata [aroma y potenciadores del sabor (E-621 y E-635)] y emulgente (E-471). Puede contener <u>proteína de leche</u>.",
        packs: "12g, 20g, 100g",
        energia: "2.012KJ, 480Kcal",
        hidratos: "64,1 g",
        azucares: "2,0 g",
        grasas: "22,9 g",
        saturadas: "2,3 g",
        fibra: "",
        sal: "2,9 g",
        proteinas: "4,4 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      trikers: {
        family: "otros-productos",
        type: "left",
        titulo: "Trikers",
        cantidadValor: "45g y 100g",
        hashtag: "#TrikersRisi",
        intro:
          "Delicioso aperitivo con auténtico sabor Tex Mex. Sin gluten y sin colorantes artificiales ¡Más por menos! ",
        introDos: "No te resistas...",
        introMovil:
          "Delicioso aperitivo con auténtico sabor Tex Mex. No te resistas...",
        ingredientes:
          " Maíz, aceite de girasol alto oleico (27.8 %), aroma tex mex [maltodextrina, dextrosa, sal, almidón de maíz, extractos de levadura, cebolla, tomate y ajo en polvo, aromas, grasa de coco, cloruro de potasio, acidulantes (ácido cítrico, ácido láctico y lactato de calcio), colorantes (extracto de pimentón y E-160b) y cayena] y pimentón dulce. Puede contener <u>proteína de leche</u>.",
        packs: "110g",
        energia: "2166KJ, 518Kcal",
        hidratos: "60,8 g",
        azucares: "2,1 g",
        grasas: "27,8 g",
        saturadas: "2,9 g",
        fibra: "",
        sal: "1,1 g",
        proteinas: "6,1 g",
        hasGluten: "0",
        hasFrutosSecos: "0",
        mostrarSinLactosa: "1"
      },
      "espelta-integral": {
        family: "desayuno",
        type: "left",
        titulo: "B-San 0% Espelta",
        packs: "160g y 480g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinLactosa: "1",
        bajoSal: "1",
        intro:
          "Deliciosas galletas <strong>0% azúcar finas y sabrosas</strong>.",
        introDos:
          " <br>Con espelta, cereal milenario, reconocido por sus múltiples propiedades nutricionales.",
        introMovil:
          "Deliciosas galletas <strong>0% azúcar finas y sabrosas</strong>.",
        ingredientes:
          "Harina de <strong><u>ESPELTA</u></strong> (68%), edulcorante (maltitol y jarabe de maltitol), aceite de girasol alto oleico, almidón de patata, harina de malta de <strong><u>CEBADA</u></strong>, harina de <strong><u>TRIGO</u></strong> con salvado (1%), gasificantes (carbonatos de sodio, carbonatos de amonio), aromas, emulgente (lecitina de girasol), colorante (E-150d) y conservador (<strong><u>METABISULFITO</u></strong> potásico). <strong>Puede contener trazas de soja, proteína de la leche y semillas de sésamo.</strong>",
        cantidadValor: "100g",
        hashtag: "#BSanEspeltaIntegral",
        energia: "1.865 kJ, 446 Kcal",
        hidratos: "64,0 g",
        azucares: "4,4 g",
        grasas: "18,0 g",
        saturadas: "2,7 g",
        fibra: "6,8 g",
        sal: "0,19g",
        proteinas: "9,9g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      integral: {
        family: "desayuno",
        type: "left",
        titulo: "B-San 0% con sésamo",
        packs: "160g y 480g",
        hasIntegral: "1",
        bajoAzucares: "1",
        bajosal: "1",
        intro:
          "Exquisitas galletas <strong>0% azúcar, integrales con calcio y sésamo</strong>.",
        introDos: "",
        introMovil:
          "Exquisitas galletas <strong>0% azúcar, integrales con calcio y sésamo</strong>.",
        ingredientes:
          "Harina de <strong><u>TRIGO</u></strong>, harina de <strong><u>TRIGO</u></strong> con salvado (16%), edulcorantes (maltitol, jarabe de maltitol), aceite de girasol alto oleico, semillas de <strong><u>SÉSAMO</u></strong> (2,6%), gasificantes (carbonatos de sodio y carbonatos de amonio), almidón de patata, harina de malta de <strong><u>CEBADA</u></strong>, mineral: calcio (carbonato de calcio), aroma, emulgente (lecitina de girasol), colorante (E-150d), conservador (<strong><u>METABISULFITO</u></strong> potásico).",
        cantidadValor: "100g",
        hashtag: "#BSanConSesamo",
        energia: "1.916 kJ, 458 Kcal",
        hidratos: "67,0 g",
        azucares: "1,3 g",
        grasas: "20,0 g",
        saturadas: "3,0 g",
        fibra: "3,3 g",
        sal: "0,18g",
        proteinas: "7,6g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      hellokitty: {
        family: "infantil",
        type: "right",
        titulo: "Hello Kitty Sin Lactosa",
        packs: "105g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        intro:
          "La gatita más querida por los niñ@s se convierte en una rica galleta.",
        introDos: " Elaborada con cereales y 6 vitaminas</strong>.",
        introMovil:
          "La gatita más querida por los niñ@s se convierte en una rica galleta.",
        ingredientes:
          "Harina multicereales (59%) (harina de <strong><u>trigo</u></strong>, harina de <strong><u>trigo</u></strong>, harina de <strong><u>avena</u></strong>, harina de malta de <strong><u>cebada</u></strong>), aceite de girasol, azúcar, jarabe de glucosa y fructosa, aromas, sal, gasificantes (carbonato de sodio y carbonato de amonio), emulgente (lecitina de girasol), vitaminas [Acetato de retinilo (vitamina A), Colecalciferol (Vitamina D), Mononitrato de tiamina (vitamina B1), Riboflavina (Vitamina B2), D-pantotenato cálcico (Ácido pantoténico), Ácido pteroilmonoglutámico (Ácido fólico)].",
        cantidadValor: "100g",
        hashtag: "#VirginiasHelloKitty",
        energia: "2.015 kJ, 480 Kcal",
        hidratos: "70,0 g",
        azucares: "24,0 g",
        grasas: "18,0 g",
        saturadas: "8,6 g",
        fibra: "2,6 g",
        sal: "0,87g",
        proteinas: "7,1g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "doraemon-sinlactosa": {
        family: "infantil",
        type: "right",
        titulo: "Doraemon Sin Lactosa",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        intro:
          "Los desayunos Doraemon harán las delicias de los peques de la casa",
        introDos:
          " con estas divertidas y saludables galletas elaboradas <strong>con maíz y 6 vitaminas</strong>.",
        introMovil:
          "Los desayunos Doraemon harán las delicias de los peques de la casa.",
        ingredientes:
          "Harinas de cereales (63%) (harina de <u><strong>trigo</u></strong>, harina de <u><strong>trigo</u></strong>, harina de <u><strong>avena</u></strong>, harina de malta de <u><strong>cebada</u></strong>), azúcar, aceite de girasol, aromas, sal, gasificantes (carbonatos de sodio y carbonatos de amonio), emulgente (lecitina de girasol), colorante (E-150d), vitaminas [Acetato de retinilo (vitamina A), Colecalciferol (Vitamina D), Mononitrato de tiamina (vitamina B1), Riboflavina (Vitamina B2), D-pantotenato cálcico (Ácido pantoténico), Ácido pteroilmonoglutámico (Ácido fólico)].",
        cantidadValor: "100g",
        hashtag: "#VirginiasDoraemon",
        energia: "1.927 kJ, 458 Kcal",
        hidratos: "72,0 g",
        azucares: "22,0 g",
        grasas: "15,0 g",
        saturadas: "2,5 g",
        fibra: "2,5 g",
        sal: "0,86g",
        proteinas: "7,5g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "almendras-caramelizadas": {
        family: "premium",
        type: "right",
        titulo: "Premium Almedras caramelizadas",
        packs: "85g",
        hasIntegral: "1",
        sinhuevo: "1",
        bajoAzucares: "1",
        intro:
          "Corazón de galleta envuelta de <strong>chocolate negro y toppings de almendras caramelizadas</strong>.",
        introDos: "",
        introMovil:
          "Galleta envuelta en <strong>chocolate negro y almendras caramelizadas</strong>.",
        ingredientes:
          "<u><strong>Galleta</u></strong> (54%): Harina de trigo, azúcar, aceite de girasol alto oleico, jarabe de glucosa y fructosa, suero de <u><strong>leche</u></strong>, <u><strong>leche</u></strong> desnatada en polvo, sal, gasificantes (carbonatos de sodio y carbonatos de amonio), emulgente (lecitina de girasol), aroma, conservador (<u><strong>metabisulfito</u></strong> potásico). <u><strong>Cobertura de chocolate negro</u></strong> (33%): Azúcar, pasta de cacao, manteca de cacao, emulgentes (lecitina de soja, E-476), aroma.  <u><strong>Almendra caramelizada de decoración</u></strong> (13%): <u><strong>Almendra</u></strong>, azúcar.",
        cantidadValor: "100g",
        hashtag: "#PremiumAlmedras",
        energia: "2.074 kJ, 495 Kcal",
        hidratos: "62,0 g",
        azucares: "37,0 g",
        grasas: "23,0 gg",
        saturadas: "8,0 g",
        fibra: "4,6 g",
        sal: "0,51g",
        proteinas: "7,8g",
        ocultarSinGluten: "1"
      },
      cacao: {
        family: "premium",
        type: "right",
        titulo: "Premium Cacao",
        packs: "85g",
        hasIntegral: "1",
        bajoAzucares: "1",
        intro:
          "Corazón de cacao envuelto de <strong>intenso chocolate negro cacao</strong>.",
        introDos: " <br>¡Pasión por el chocolate!",
        introMovil:
          "Corazón de cacao envuelto de <strong>intenso chocolate negro cacao</strong>.",
        ingredientes:
          "<strong>Cobertura de chocolate negro</strong> (55%): Azúcar, pasta de cacao, manteca de cacao, emulgentes (lecitina de <u><strong>soja</u></strong>, E-476), aroma. <u><strong>Galleta</u></strong> (45%): Harina de trigo, azúcar, aceite de girasol alto oleico,  jarabe de glucosa y fructosa, suero de <u><strong>leche</u></strong>, <u><strong>leche</u></strong> desnatada en polvo, sal, gasificantes (carbonatos de sodio y carbonatos de amonio),  emulgente (lecitina de girasol), conservador (<u><strong>metabisulfito</u></strong> potásico), aroma.",
        cantidadValor: "100g",
        hashtag: "#PremiumCacao",
        energia: "2.105 kJ, 503 Kcal",
        hidratos: "62,0 g",
        azucares: "39,0 g",
        grasas: "24,0 g",
        saturadas: "11,0 g",
        fibra: "5,3 g",
        sal: "0,37g",
        proteinas: "7,1 g",
        ocultarSinGluten: "1"
      },
      naranja: {
        family: "premium",
        type: "right",
        titulo: "Premium Naranja intensa",
        packs: "85g",
        hasIntegral: "1",
        bajoAzucares: "1",
        intro:
          "Corazón de galleta envuelto de <strong>chocolate negro cacao</strong>.",
        introDos: " <br>¡Y topping de chocolate a la naranja!",
        introMovil:
          "Galleta envuelta en <strong>chocolate negro cacao</strong>.",
        ingredientes:
          "<u><strong>Cobertura de chocolate negro</u></strong>  (48%): Azúcar, pasta de cacao, manteca de cacao, emulgentes (lecitina de <u><strong>soja</u></strong> , E-476), aroma. <u><strong>Galleta</u></strong>  (44%):  Harina de <u><strong>trigo</u></strong> , azúcar, aceite de girasol alto oleico, jarabe de glucosa y fructosa, suero de <u><strong>leche</u></strong> , <u><strong>leche</u></strong>  desnatada en polvo, sal, gasificantes (carbonatos de sodio y carbonatos de amonio),  emulgente (lecitina de girasol), conservador (metabisulfito potásico), aroma. <u><strong>Chocolate con leche de decoración</u></strong> (8%): Azúcar, manteca de cacao, <u><strong> leche</u></strong> entera en polvo, pasta de cacao, suero de leche en polvo, zumo de naranja concentrado (0,1%),  emulgente (lecitina de <u><strong> soja</u></strong> ), aromas. ",
        cantidadValor: "100g",
        hashtag: "#PremiumNaranjaIntensa",
        energia: "2.119 kJ, 507 Kcal",
        hidratos: "61,0 g",
        azucares: "40,0 g",
        grasas: "25,0 g",
        saturadas: "12,0 g",
        fibra: "4,8 g",
        sal: "0,44g",
        proteinas: "7,0 g",
        ocultarSinGluten: "1"
      },
      supermaria: {
        family: "tradicionales",
        type: "left",
        titulo: "Súper María 0%",
        packs: "432g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        sinhuevo: "1",
        intro: "Las María de toda la vida, más deliciosas que nunca.",
        introDos: " <br><strong>Enriquecidas con sésamo</strong>.",
        introMovil:
          "Las María de toda la vida, <strong>enriquecidas con sésamo</strong>.",
        ingredientes:
          "Harina de <u><strong>trigo</u></strong>, Harina de <u><strong>trigo</u></strong> con salvado, harina de trigo (22%),  aceite de girasol alto oleico, edulcorante (maltitol),  semillas de <u><strong>sésamo</u></strong> (3%), zumo concentrado de manzana, almidón de patata,  gasificantes (carbonatos de sodio y carbonatos de amonio), emulgente (lecitina de girasol), aroma, conservador (<u><strong>metabisulfito</u></strong> potásico). Puede contener trazas de proteína de leche y soja.",
        cantidadValor: "100g",
        hashtag: "#VirginiaSúperMaría",
        energia: "1.976 kJ, 472 Kcal",
        hidratos: "65,0g",
        azucares: "2,9 g",
        grasas: "22,0 g",
        saturadas: "3,4 g",
        fibra: "3,6 g",
        sal: "0,21g",
        proteinas: "7,4 g",
        ocultarSinGluten: "1",
        mostrarSinLactosa: "1"
      },
      "digestiva-chocolate": {
        family: "tradicionales",
        type: "left",
        titulo: "Galletas Digestiva Chocolate Sin gluten",
        packs: "135g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        hasGluten: "0",
        intro:
          "Galletas digestivas <strong>recubieras de un suave y delicioso chocolate negro…</strong>",
        introDos: "¡una nueva receta que no puedes dejar de probar!",
        introMovil:
          "Galletas digestivas <strong>recubieras de chocolate negro…</strong>",
        ingredientes:
          "Almidón de maíz (44%), cobertura de chocolate negro (18%): (pasta de cacao, fructosa, manteca de cacao, cacao en polvo, emulgente (lecitina de <u><strong>SOJA</u></strong>), aroma), grasa de coco, aceite de girasol, azúcar moreno de caña, harina de arroz, dextrina de maíz, albúmina de <u><strong>HUEVO</u></strong>, harina de <u><strong>SOJA</u></strong>, fécula de patata, proteína de <u><strong>SOJA</u></strong>, dextrosa, azúcar líquido invertido, <u><strong>HUEVO</u></strong> líquido pasteurizado, gasificantes (carbonatos de sodio y carbonatos de amonio), sal, humectante (sorbitol), espesantes (goma guar, goma xantana), emulgente (lecitina de <u><strong>SOJA</u></strong>) y aroma. <strong>Puede contener trazas de <u>leche</u>, <u>frutos de cáscara</u> y semillas de <u>sésamo</u>.</strong> ",
        cantidadValor: "100g",
        hashtag: "#VirginiaDigestivaChocolate",
        energia: "2.057 kJ, 491 Kcal",
        hidratos: "64,0 g",
        azucares: "20,0 g",
        grasas: "23,0 g",
        saturadas: "11,0 g",
        fibra: "4,8 g",
        sal: "3,3g",
        proteinas: "4,7 g",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "hellokitty-singluten": {
        family: "tradicionales",
        type: "right",
        titulo: "Hello Kitty Sin Gluten",
        packs: "120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinlactosa: "1",
        intro:
          "La gatita más querida por los niñ@s se convierte en una rica galleta",
        introDos:
          " <strong>elaborada con maíz</strong> que hará las delicias de los peques de la casa.",
        introMovil:
          "La gatita más querida por los niñ@s se convierte en una rica galleta.",
        ingredientes:
          "Almidón de maíz (50%),grasa vegetal de palma ,aceite de <u><strong>SOJA</u></strong> y girasol , azúcar moreno de caña, harina de arroz, harina de <u><strong>SOJA</u></strong>, dextrina de maíz, albúmina de <u><strong>HUEVO</u></strong>, fécula de patata, azúcar invertido, <u><strong>PROTEINA DE SOJA</u></strong> , <u><strong>HUEVO</u></strong> líquido pasteurizado, dextrosa, gasificantes (carbonatos de amonio y de sodio), sal, estabilizante (sorbitol), espesante (goma guar), aroma, emulgente (lecitina de <u><strong>SOJA</u></strong>). <strong>Puede contener trazas de <u>frutos de cáscara</u> y semillas de sésamo.</strong>",
        cantidadValor: "100g",
        hashtag: "#VirginiasHelloKitty",
        energia: "1.996 kJ, 475 Kcal",
        hidratos: "73,0 g",
        azucares: "18,0 g",
        grasas: "17,0 g",
        saturadas: "7,0 g",
        fibra: "3,0 g",
        sal: "0,35g",
        proteinas: "6,0 g",
        mostrarSinLactosa: "1",
        hasFrutosSecos: "1"
      },
      "doraemon-sin-gluten": {
        family: "tradicionales",
        type: "right",
        titulo: "Doraemon Sin Gluten",
        packs: "150g",
        hasIntegral: "1",
        bajoAzucares: "1",
        intro:
          "Los desayunos Doraemon harán las delicias de los peques de la casa",
        introDos:
          " con estas <strong>divertidas y saludables galletas</strong>.",
        introMovil:
          "Los desayunos Doraemon harán las delicias de los peques de la casa.",
        ingredientes:
          "Harinas de cereales (66 %) (harina de <u><strong>TRIGO</strong></u>, harina con salvado de <u><strong>TRIGO</u></strong>, harina de <u><strong>AVENA</u></strong>, harina de malta de <u><strong>CEBADA</strong></u>), azúcar, aceite de girasol alto oleico, gasificantes (carbonatos de sodio y carbonatos de amonio), aromas, sal, emulgente (lecitina de girasol), colorante (E-150d), vitaminas [Acetato de retinilo (vitamina A), Colecalciferol (Vitamina D), Mononitrato de tiamina (vitamina B1), Riboflavina (Vitamina B2), D-pantotenato cálcico (Ácido pantoténico), Ácido pteroilmonoglutámico (Ácido fólico)].",
        cantidadValor: "100g",
        hashtag: "#VirginiasDoraemon",
        energia: "1.957 kJ, 466 Kcal",
        hidratos: "73,0 g",
        azucares: "20,0 g",
        grasas: "17,0 g",
        saturadas: "5,6 g",
        fibra: "2,2 g",
        sal: "3,33g",
        proteinas: "4,1g",
        hasFrutosSecos: "1"
      },
      "cacao-intenso": {
        family: "chocolate",
        type: "left",
        titulo: "B-San 0% Cacao intenso ",
        packs: "80g, 120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "El placer de una galleta con avena totalmente <strong>bañada de intenso cacao</strong>.",
        introDos: " ¿Hay algo mejor para un auténtico chocolate lovers?",
        introMovil:
          "El placer de una galleta con avena <strong>bañada de cacao</strong>.",
        ingredientes:
          "<u><strong>Cobertura de chocolate negro sin azúcares añadidos con edulcorantes</u></strong> (55%): Edulcorante (maltitol), pasta de cacao, manteca de cacao, <u><strong>mantequilla</u></strong> anhidra, emulgentes (lecitina de <u><strong>soja</u></strong>, E-476), aroma, edulcorante (acesulfamo K). <u><strong>Galleta sin azúcares añadidos con edulcorantes</u></strong> (45%): Harina de <u><strong>trigo</u></strong>, harina  de <u><strong>trigo</u></strong> (15%), edulcorante (maltitol), aceite de girasol alto oleico, cereal (<u><strong>avena</u></strong>: 3%), edulcorante (jarabe de maltitol), harina de malta de <u><strong>cebada</u></strong>, harína de <u>trigo</u> con salvado, almidón de patata, gasificantes (carbonatos de sodio y carbonatos de amonio), aroma, emulgente (lecitina de girasol), vitaminas [Acetato de retinilo (vitamina A), Colecalciferol (Vitamina D), Mononitrato de tiamina (Vitamina B1), Riboflavina (Vitamina B2), D-pantotenato cálcico (Ácido pantoténico), Ácido pteroilmonoglutámico (Ácido fólico)], conservador (<u><strong>metabisulfito</u></strong> potásico). Puede contener frutos de cáscara y semillas de sésamo.",
        cantidadValor: "100g",
        hashtag: "#BSanCacaoIntenso",
        energia: "1.890 kJ, 454 Kcal",
        hidratos: "60,0 g",
        azucares: "0,9 g",
        grasas: "25,0 g",
        saturadas: "12,0 g",
        fibra: "5,9 g",
        sal: "0,17g",
        proteinas: "7,6 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "chocolate-con-leche": {
        family: "chocolate",
        type: "left",
        titulo: "B-San 0% Chocolate con leche",
        packs: "80g, 120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "El placer de una galleta con avena bañada en chocolate con leche.",
        introDos: " <strong>¡Y con ácido fólico!</strong>",
        introMovil:
          "El placer de una galleta con avena bañada en chocolate con leche.",
        ingredientes:
          "Cobertura de chocolate con leche sin azúcares añadidos con edulcorantes (50%): Edulcorante (maltitol), <u><strong>leche</u></strong> en polvo, harína de <u><strong>trigo</u></strong> con salvado, pasta de cacao,  manteca de cacao,  <u><strong>mantequilla</u></strong> anhidra, emulgentes (E-442, E-476), aromas, edulcorante (acesulfamo K). GALLETA SIN AZÚCARES AÑADIDOS CON EDULCORANTES (50%): Harina de <u><strong>trigo</u></strong>, harina  de <u><strong>trigo</u></strong> (15%), edulcorante (maltitol), aceite de girasol alto oleico, cereal: <u><strong>avena</u></strong> (3%), edulcorante (jarabe de maltitol), harina de malta de <u><strong>cebada</u></strong>, almidón de patata, gasificantes (carbonatos de sodio y carbonatos de amonio), aroma, emulgente (lecitina de girasol), vitaminas [Acetato de retinilo (vitamina A), Colecalciferol (Vitamina D), Mononitrato de tiamina (Vitamina B1), Riboflavina (Vitamina B2), D-pantotenato cálcico (Ácido pantoténico), Ácido pteroilmonoglutámico (Ácido fólico)],  conservador (<u><strong>metabisulfito</u></strong> potásico). Puede contener frutos de cáscara y semillas de sésamo.",
        cantidadValor: "100g",
        hashtag: "#BSanChocolateConLeche",
        energia: "1.931 kJ, 464 Kcal",
        hidratos: "59,0 g",
        azucares: "5,0 g",
        grasas: "26,0 g",
        saturadas: "13,0 g",
        fibra: "3,5 g",
        sal: "0,28g",
        proteinas: "7,9 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "chocolate-blanco": {
        family: "chocolate",
        type: "left",
        titulo: "B-San 0%Chocolate blanco",
        packs: "80g, 120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        chocolatelovers: "1",
        intro:
          "El placer de una galleta bañada en un intenso <strong>chocolate blanco</strong>,",
        introDos: " <br>con avena y ácido fólico.",
        introMovil:
          "El placer de una galleta bañada en un intenso <strong>chocolate blanco</strong>.",
        ingredientes:
          "<strong>Cobertura de chocolate blanco sin azúcares añadidos con edulcorantes</u></strong> (55%): Edulcorante (maltitol), manteca de cacao,  harína de <u><strong>trigo</u></strong> con salvado, <u><strong>leche</u></strong> entera en polvo, emulgente (lecitina de <u><strong>soja</u></strong>), aroma, edulcorante (acesulfamo K). <strong>Galleta sin azúcares añadidos con edulcorantes</strong> (45%): Harina de <u><strong>trigo</u></strong>, harina de <u><strong>trigo</u></strong> (14%), edulcorante (maltitol), aceite de girasol alto oleico,  cereal (<u><strong>avena</u></strong>: 2,8%),  edulcorante (jarabe de maltitol), harina de malta de <u><strong>cebada</u></strong>, almidón de patata, cacao en polvo (1,6%), oligofructosa (3%), gasificantes (carbonatos de sodio y carbonatos de amonio), aroma, emulgente (lecitina de girasol), vitaminas [Acetato de retinilo (vitamina A), Colecalciferol (Vitamina D), Mononitrato de tiamina (vitamina B1), Riboflavina (Vitamina B2), D-pantotenato cálcico (Ácido pantoténico), Ácido pteroilmonoglutámico (Ácido fólico)], conservador (<u><strong>metabisulfito</u></strong> potásico). Puede contener frutos de cáscara y semillas de sésamo.",
        cantidadValor: "100g",
        hashtag: "#BSanChocolateBlanco",
        energia: "1.955 kJ, 470 Kcal",
        hidratos: "61,0 g",
        azucares: "5,6 g",
        grasas: "27,0 g",
        saturadas: "13,0 g",
        fibra: "3,0 g",
        sal: "0,25g",
        proteinas: "7,4 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "chocolate-naranja": {
        family: "chocolate",
        type: "left",
        titulo: "B-San 0% Chocolate a la Naranja",
        packs: "80g, 120g",
        hasIntegral: "1",
        bajoAzucares: "1",
        sinhuevo: "1",
        chocolatelovers: "1",
        intro: "Descubre un sabor muy especial.",
        introDos:
          " <br>Elaborada con avena y <strong>bañada en chocolate a la naranja con Stevia</strong>.",
        introMovil:
          "Elaborada con avena y <strong>bañada en chocolate a la naranja con Stevia</strong>.",
        ingredientes:
          "<strong>Cobertura de chocolate negro sin azúcares añadidos con edulcorantes</u></strong> (47%): Edulcorante (maltitol), pasta de cacao, harína de <u><strong>trigo</u></strong> con salvado, manteca de cacao, <u><strong>mantequilla</u></strong> , anhidra, emulgentes (lecitina de <u><strong>soja</u></strong>), aroma, edulcorante (glucósidos de esteviol). <strong>Galleta sin azúcares añadidos con edulcorantes</strong> (45%): Harina de <u><strong>trigo</u></strong>, harina de <u><strong>trigo</u></strong> (15%), edulcorante (maltitol), aceite de girasol alto oleico,  cereal (<u><strong>avena</u></strong>: 3%),  edulcorante (jarabe de maltitol), harina de malta de <u><strong>cebada</u></strong>, almidón de patata, gasificantes, (carbonatos de sodio y carbonatos de amonio), aroma, emulgente (lecitina de girasol), vitaminas [Acetato de retinilo (vitamina A), Colecalciferol (Vitamina D), Mononitrato de tiamina (vitamina B1), Riboflavina (Vitamina B2), D-pantotenato cálcico (Ácido pantoténico), Ácido pteroilmonoglutámico (Ácido fólico)], conservador (<u><strong>metabisulfito</u></strong> potásico). Puede contener frutos de cáscara y semillas de sésamo.",
        cantidadValor: "100g",
        hashtag: "#BSanChocolateNaranja",
        energia: "1.849 kJ, 444 Kcal",
        hidratos: "60,0 g",
        azucares: "1,4 g",
        grasas: "24,0 g",
        saturadas: "12,0 g",
        fibra: "5,5 g",
        sal: "0,13g",
        proteinas: "7,5 g",
        ocultarSinGluten: "1",
        hasFrutosSecos: "1"
      },
      "mix-melon-sandia": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix Melón y Sandía",
        packs: "85g, 940g",
        bajoAzucares: "1",
        sinlactosa: "1",
        intro:
          "Deliciosos caramelos blandos con <strong>zumo de melón y sandía</strong> y un intenso sabor.",
        introDos: " ¡Edulcorados con Stevia!",
        introMovil:
          "Deliciosos caramelos blandos con <strong>zumo de melón y sandía</strong>.",
        ingredientes: "",
        hashtag: "#MixMelón&Sandía",
        energia: "1.097 kJ, 263 Kcal",
        hidratos: "90g",
        azucares: "",
        grasas: "4,2g",
        saturadas: "",
        fibra: "",
        sal: "0,05g",
        proteinas: "0g"
      },
      "mix-frutos-rojos": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix Frutos Rojos",
        packs: "85g, 940g",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Deliciosos caramelos blandos con zumo de frutos rojos y un intenso sabor.",
        introDos: "¡Edulcorados con Stevia!",
        introMovil:
          "Deliciosos caramelos blandos con zumo de frutos rojos y un intenso sabor.",
        ingredientes: "",
        hashtag: "#MixFrutosRojos",
        energia: "1.097 kJ, 263 Kcal",
        hidratos: "90g",
        azucares: "",
        grasas: "4,2g",
        saturadas: "",
        fibra: "",
        sal: "0,05g",
        proteinas: "0g"
      },
      "mix-5-frutas": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix 5 Frutas",
        packs: "85g, 940g",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Deliciosos caramelos blancos con zumo de frutas y un intenso sabor.",
        introDos: "",
        introMovil:
          "Deliciosos caramelos blancos con zumo de frutas y un intenso sabor.",
        ingredientes: "",
        hashtag: "#Mix5Frutas",
        energia: "1.097 kJ, 263 Kcal",
        hidratos: "90g",
        azucares: "",
        grasas: "4,2g",
        saturadas: "",
        fibra: "",
        sal: "0,05g",
        proteinas: "0g"
      },
      citricos: {
        family: "citrico",
        type: "left",
        titulo: "Virginias 0% Cítricos",
        packs: "110g, 925g",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Deliciosos caramelos de frutas, <strong>sabor naranja y limón</strong>.",
        introDos: " <br>¡Dulces momentos SIN!",
        introMovil:
          "Deliciosos caramelos de frutas, <strong>sabor naranja y limón</strong>.",
        ingredientes: "",
        hashtag: "#VirginiasCítricos",
        energia: "970 kJ, 233 Kcal",
        hidratos: "97g",
        azucares: "",
        grasas: "0g",
        saturadas: "",
        fibra: "",
        sal: "0,15g",
        proteinas: "0g"
      },
      frutas: {
        family: "citrico",
        type: "left",
        titulo: "Virginias 0% Frutas",
        packs: "930g",
        mostrarsinlactosa: "1",
        intro: "Delicioso surtido de sabor frutas.",
        introDos: "<br>¡Dulces momentos SIN!",
        introMovil: "Delicioso surtido de sabor frutas.",
        ingredientes: "",
        hashtag: "#VirginiasFrutas",
        energia: "kJ,Kcal",
        hidratos: "g",
        azucares: "",
        grasas: "g",
        saturadas: "",
        fibra: "",
        sal: "g",
        proteinas: "g"
      },
      stevia: {
        family: "citrico",
        type: "left",
        titulo: "Virginias 0% Stevia",
        packs: "98g",
        bajoAzucares: "1",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Delicioso surtido de <strong>caramelos con Stevia</strong> sabor frutas.",
        introDos: "<br>¡Dulces momentos SIN!",
        introMovil:
          "Delicioso surtido de <strong>caramelos con Stevia</strong> sabor frutas.",
        ingredientes: "",
        hashtag: "#VirginiasFruitSin",
        energia: "970 kJ, 233 Kcal",
        hidratos: "97g",
        azucares: "",
        grasas: "0g",
        saturadas: "",
        fibra: "",
        sal: "0,15g",
        proteinas: "0g"
      },
      balsamicos: {
        family: "balsamicos",
        type: "left",
        titulo: "Glasssmins 0%",
        packs: "105g, 465g, 930g",
        bajoAzucares: "1",
        ocultarSinGluten: "1",
        sinlactosa: "1",
        intro: "Refrescantes caramelos que aclaran tu garganta.",
        introDos: "",
        introMovil: "Refrescantes caramelos que aclaran tu garganta.",
        ingredientes: "",
        hashtag: "#VirginiasGlassmins",
        energia: "980 kJ, 235 Kcal",
        hidratos: "98g",
        azucares: "",
        grasas: "0g",
        saturadas: "",
        fibra: "",
        sal: "0,10g",
        proteinas: "0g"
      },
      "mix-variado": {
        family: "0-azucares",
        type: "left",
        titulo: "Mix Caramelos Blandos",
        packs: "160g, 480g, 950g",
        hasGluten: "0",
        sinlactosa: "1",
        intro: "¡Simplemente deliciosos!",
        introDos: "",
        introMovil: "¡Simplemente deliciosos!",
        ingredientes: "",
        hashtag: "#MixFrutasDelSol",
        energia: "970 kJ, 233 Kcal",
        hidratos: "97g",
        azucares: "",
        grasas: "0g",
        saturadas: "",
        fibra: "",
        sal: "0,15g",
        proteinas: "0g"
      },
      "azucares-gajos": {
        family: "citrico",
        type: "left",
        titulo: "Frutas del Sol Gajos",
        packs: "165g, 485g, 950g",
        hasGluten: "0",
        sinlactosa: "1",
        intro:
          "Caramelos de <strong>naranja y limón</strong>. Dulces momentos con sabor a fruta.",
        introDos: "",
        introMovil:
          "Caramelos de <strong>naranja y limón</strong>. Dulces momentos con sabor a fruta.",
        ingredientes: "",
        hashtag: "#FrutasDelSolGajos",
        energia: "1.632 kJ, 384 Kcal",
        hidratos: "96g",
        azucares: "",
        grasas: "0g",
        saturadas: "",
        fibra: "",
        sal: "0,15g",
        proteinas: "0g"
      },
      doble: {
        family: "citrico",
        type: "left",
        titulo: "Frutas del Sol Dooble",
        packs: "130g, 465g, 930g",
        hasGluten: "0",
        sinlactosa: "1",
        intro: "Caramelos de <strong>seis sabores</strong> intensos de fruta.",
        introDos: "<br>Dulces momentos con sabor a fruta.",
        introMovil:
          "Caramelos de <strong>seis sabores</strong> intensos de fruta.",
        ingredientes: "",
        hashtag: "FrutasDelSolDooble",
        energia: "1.632 kJ, 384 Kcal",
        hidratos: "96g",
        azucares: "",
        grasas: "0g",
        saturadas: "",
        fibra: "",
        sal: "0,15g",
        proteinas: "0g"
      },
      "frutas-acidas": {
        family: "citrico",
        type: "left",
        titulo: "Frutas Ácidas",
        packs: "465g",
        sinlactosa: "1",
        hasGluten: "0",
        intro: "Dulces momentos con sabor a <strong>frutas ácidas</strong>.",
        introDos: "",
        introMovil:
          "Dulces momentos con sabor a <strong>frutas ácidas</strong>.",
        ingredientes: "",
        hashtag: "#FrutasDelSolÁcidas",
        energia: "1.632 kJ, 384 Kcal",
        hidratos: "96g",
        azucares: "",
        grasas: "0g",
        saturadas: "",
        fibra: "",
        sal: "0,15g",
        proteinas: "0g"
      }
    },
    regulatory_compliance: {
      ethical: {
        label: "CANAL ÉTICO",
        title: "POLÍTICA GENERAL DEL SISTEMA INTERNO DE INFORMACIÓN",
        objetive: "Objetivo:",
        descrip1:
          "Establecer el procedimiento a seguir en caso de detectar cualquier incidencia o comportamiento contrario al Código de Conducta de la compañía, infracción normativa o susceptible de generar responsabilidad penal.",
        introduction: "1. Introducción",
        descrip2:
          "La Ley 2/2023, de 20 de febrero, reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción (en adelante, Ley 2/2023) establece los elementos que integran el Sistema Interno de Información, entre ellos, la Política General del Sistema Interno de Información (la cual incorpora las garantías de protección a los informantes), el Procedimiento del Sistema Interno de Información, y el Canal Ético de Información de APERITIVOS MATARILE.",
        descrip3:
          "El Administrador Único de APERITIVOS MATARILE, S.A. (en adelante, “APERITIVOS MATARILE”), en su voluntad de cumplir con la legislación vigente en cada momento, aprueba y suscribe la presente Política (en adelante, la “Política”) como parte del Sistema Interno de Información implantado en la entidad de APERITIVOS MATARILE.",
        descrip4:
          "Asimismo,  nombró  en  su momento al Responsable del Sistema Interno de Información.",
        subjective: "2. Ámbito subjetivo",
        descrip5:
          "Esta Política se aprueba con el fin de establecer los principios básicos del Sistema Interno de Información de APERITIVOS MATARILE y, en concreto del Canal Ético, que está disponible para los siguientes informantes:",
        descrip6:
          "Miembros de la Junta de Accionistas, los Órganos de Administración y empleados que forman parte de APERITIVOS MATARILE (incluyendo exempleados, en prácticas, en proceso de selección, trabajadores autónomos).",
        descrip7:
          "Empleados de proveedores, contratistas, subcontratistas o socios de negocio.",
        descrip8:
          "Todos aquellos terceros con los que APERITIVOS MATARILE mantenga una relación profesional directa o indirectamente.",
        communication: "3. Definición de comunicación",
        descrip9: "La  consulta  se  define  como  la  solicitud  de  información  para  conocer  la  interpretación  de  los principios y directrices contenidos en el Código de Conducta y la normativa interna que nos es de aplicación.",
        descrip11:
          "La información o denuncia se define como una inquietud sobre un posible incumplimiento o comportamiento contrario al código de conducta, políticas, procedimientos de Aperitivos Matarile, comunicadas de buena fe y conscientemente por un empleado o tercera parte a través del Canal Ético de APERITIVOS MATARILE.",
        descrip12:
          "La Política pretende regular la forma en que se gestionan las informaciones recibidas sobre conductas que afecten a los profesionales de APERITIVOS MATARILE y puedan suponer la comisión de un delito o infracción de la normativa de aplicación.",
        scopeMaterial:
          "4. Ámbito material del Sistema Interno de Información de APERITIVOS MATARILE",
        descrip14:
          "A través del Canal Ético de APERITIVOS MATARILE se podrán presentar consultas o denuncias referentes a la normativa de aplicación a la actividad de APERITIVOS MATARILE.",
        descrip15: "En concreto, se podrán comunicar:",
        descrip17:
          "Consultas: se referirá al alcance y la aplicabilidad del Código de Conducta o de algún elemento del Sistema de Cumplimiento en su conjunto a través de <a style='font-weight: bold; text-decoration: underline;' href='mailto:consultacodigo@matarile.es'>consultacodigo@matarile.es</a>",
        descrip18:
          "Denuncias sobre posibles incumplimientos del Sistema: se referirá a cualquier incumplimiento de los elementos del Sistema de Cumplimiento que comprende en este concepto todas las infracciones del Código de Conducta, de cualquier otro elemento del Sistema o de cualquier otra normativa interna, así como las infracciones de cualquier normativa externa, legislación o regulación integrante del ordenamiento jurídico que resulte de aplicación, incluyendo especialmente (pero no exclusivamente) las infracciones graves o muy grave de naturaleza administrativa o penal (con especial atención a las conductas corruptas) y de la normativa de defensa  de la competencia, por su especial gravedad y por el compromiso específico que APERITIVOS MATARILE asume respecto a su cumplimiento. En especial, se incluyen las materias referidas en la Ley 2/2023, de 20 de febrero, reguladora de la protección de las personas que informan de infracciones normativas y de lucha contra la corrupción para cuyos casos se asegurará la aplicación de los principios y prescripciones en ella establecidos. A través de <a style='font-weight: bold; text-decoration: underline;' href='mailto:canaletico@matarile.es'>canaletico@matarile.es</a>",
        descrip190: "<strong style='font-weight: bold;'>Quedan excluidas del alcance del presente procedimiento las informaciones vinculadas a reclamaciones sobre conflictos interpersonales o que afecten únicamente al informante y a las personas a las que se refiera la comunicación.</strong>",
        descrip19:
          "El Órgano de Gobierno de APERITIVOS MATARILE ha designado a la Responsable de Cumplimiento como Responsable del Sistema Interno de Información y, por tanto, para la gestión de las informaciones o denuncias a través del Canal Ético.",
        informant: "5. Derechos del informante",
        descrip23:
          "El Órgano de Gobierno de APERITIVOS MATARILE establece que el Canal Ético de Información de APERITIVOS MATARILE se rige de conformidad a los siguientes principios: ",
        descrip24:
          "<strong style='font-weight: bold; text-decoration: underline;'>Principio de buena fe.</strong> Todos los integrantes de APERITIVOS MATARILE y todas las terceras partes de conformidad con lo previsto en el ámbito subjetivo del Sistema Interno de Información, deben actuar de buena fe y no hacer acusaciones falsas al manifestar sus inquietudes. La buena fe consiste en dar información sin malicia, sin considerar el beneficio personal y considerando la información veraz de forma razonable y con los medios de que dispone. El denunciante que deliberadamente haga declaraciones falsas o engañosas o de mala fe, podrá́ ser objeto de acciones disciplinarias de conformidad con la legislación vigente.",
        descrip25:
          "<strong style='font-weight: bold; text-decoration: underline;'>Compromiso de no represalia.</strong> APERITIVOS MATARILE establece formalmente que no tolerará represalias de ningún tipo cometidas sobre aquellas personas que hagan uso de los procedimientos establecidos para la comunicación de conductas irregulares.",
        descrip26:
          "<strong style='font-weight: bold; text-decoration: underline;'>Derecho a ser informado.</strong> El denunciante o informante tiene derecho de ser informado desde la presentación de la consulta o denuncia. A estos efectos recibirá acuse de recibo de la recepción de su denuncia en el plazo de siete (7) días naturales. Asimismo, pondrá en su conocimiento, la admisión o no de la misma, o, en su caso, la existencia de una investigación interna y de su resolución en el plazo de tres (3) meses desde la recepción de la comunicación, salvo casos de especial complejidad en que este plazo podrá ser ampliado otros tres meses.",
        descrip27:
          "<strong style='font-weight: bold; text-decoration: underline;'>Derecho a la protección de los datos personales.</strong> Según la normativa vigente los Datos Personales deberán ser protegidos y tratados conforme a la Ley 2/2023, de 20 de febrero reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción y la normativa de protección de datos vigente. El denunciante puede presentar denuncias anónimas (sin identificarse), tiene derecho a conservar el anonimato cuando presente una comunicación o denuncia debiendo ser protegido en dicho derecho.",
        descrip28:
          "<strong style='font-weight: bold; text-decoration: underline;'>Confidencialidad.</strong> Se adoptarán las medidas necesarias para preservar la identidad y garantizar la confidencialidad de los datos correspondientes a todas las personas afectadas por la información suministrada en las denuncias. En especial, en el caso de denuncias no anónimas, la identidad del denunciante deberá mantenerse confidencial en todas las etapas del proceso de investigación y resolución de la denuncia, por lo que no se divulgará a terceros ni, por tanto, a la persona denunciada, ni tampoco a los mandos directivos del denunciante. Sin perjuicio de lo anterior, los datos del denunciante y del resto de intervinientes podrán ser objeto de comunicación a terceros para la adecuada gestión de la investigación y a los Juzgados o Tribunales, Ministerio Fiscal, Fuerzas y Cuerpos de Seguridad del Estado y demás autoridades competentes cuando resulte necesario para la tramitación de los procedimientos judiciales que, en su caso, procedan como consecuencia de las investigaciones llevadas a cabo con motivo de las denuncias formuladas. ",
        accused: "6. Derechos y deberes del denunciado",
        descrip29:
          "<strong style='font-weight: bold; text-decoration: underline;'>Derecho al honor, a la presunción de inocencia y de defensa.</strong> El derecho al honor de las personas es una de las máximas de actuación de APERITIVOS MATARILE. En ese sentido, pondremos la mayor atención en velar por tales derechos, garantizando los derechos de las personas denunciadas a defenderse de cualesquiera acusaciones que se dirigieran contra ellas con las máximas garantías legales.  La persona afectada podrá hacer uso de sus dere-chos de defensa y ser asistida por la representación legal que estime oportuna.",
        descrip30:
          "<strong style='font-weight: bold; text-decoration: underline;'>Derecho a ser informado.</strong> La persona denunciada será informada de la instrucción de un procedimiento de investigación por hechos ilícitos o ilegales que pudieran serle atribuidos. En el plazo más breve posible, se le comunicará los hechos objeto de investigación y velará por el legítimo respeto a sus derechos de defensa y presunción de inocencia.",
        descrip31:
          "<strong style='font-weight: bold; text-decoration: underline;'>Derecho a la protección de los datos personales.</strong> Según la normativa vigente los Datos Personales deberán ser protegidos y tratados conforme a la Ley 2/2023, de 20 de febrero reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción y normativa de protección de datos de aplicación. Se le informará de que sus datos han sido obtenidos a través del Cana Ético cuya finalidad consiste en investigar, tramitar y resolver las comunicaciones recibidas. Solo en caso de ser necesario, al objeto de la investigación, tramitación y/o resolución, la información podrá ser cedida a terceros en cumplimiento de las obligaciones legales oportunas.",
        channel: "7. Canal Ético de APERITIVOS MATARILE",
        descrip33:
          "El Canal Ético de APERITIVOS MATARILE es un medio seguro y confidencial que permite a los empleados y otras partes interesadas informar de conductas inapropiadas, irregularidades o cualquier otra situación que pueda suponer una infracción normativa de conformidad con lo previsto en la Ley 2/2023 y afectar negativamente la reputación de APERITIVOS MATARILE.",
        descrip34:
          "El Canal Ético de Información de APERITIVOS MATARILE permite la presentación de:",
        descrip35:
          "<strong style='font-weight: bold; text-decoration: underline;'>Comunicación escrita:</strong> a través de dirección de correo electrónico. ",
        descrip36:
          "<strong style='font-weight: bold; text-decoration: underline;'>Comunicación presencial:</strong> previa solicitud del informante.",
        descrip37:
          "Las comunicaciones o informaciones de acuerdo con el ámbito de aplicación de esta política también se podrán remitir a la Autoridad Independiente de Protección del Informante y a las autoridades u órganos autonómicos correspondientes, a través de sus respectivos canales habilitados para estos efectos. De igual forma, se podrán comunicar dichos hechos a las autoridades creadas al efecto por los organismos y autoridades de cualquier otro país de la Unión Europea.",
        protection: "8. Protección de datos de carácter personal",
        descrip38:
          "Los datos suministrados a través del Canal Ético de Información de APERITIVOS MATARILE se utilizarán con el fin de gestionar las comunicaciones relacionadas con dicho canal, así como para realizar las investigaciones necesarias, impulsar la gestión y determinar si se ha producido alguna infracción o delito.",
        descrip39:
          "El acceso al Canal Ético de Información de APERITIVOS MATARILE y a los datos en él contenidos está limitado exclusivamente al Responsable del Sistema Interno de Información de APERITIVOS MATARILE, el equipo gestor asignado al mismo, al responsable de RRHH u órgano designado para la imposición de medidas disciplinarias, Responsable Legal, los encargados de tratamiento que eventualmente se designen y el DPO de la entidad. No obstante, el Responsable del Sistema Interno de Información podrá comunicar los datos a terceros, cuando resulte necesario para la tramitación de los procedimientos administrativos o judiciales que, en su caso, procedan.",
        "btn-accept": "ACEPTAR Y CONTINUAR",
        descrip41:
          "El Canal Ético es el canal de comunicación que MATARILE pone a disposición para:",
        queries: "<strong>Dudas o Consultas</strong>",
        descrip42:
          "Plantear dudas o consultas sobre la normativa interna de conducta de MATARILE. En este sentido, puedes contactar con tu Director de área o directamente con el Responsable de Cumplimiento, enviando tus preguntas a la siguiente dirección de correo electrónico: <a style='text-decoration: underline;' href='mailto:consultacodigo@matarile.es'>consultacodigo@matarile.es</a>",
        violations: "<strong>Infracciones o Incumplimientos</strong>",
        descrip43:
          "Informar sobre cualquier incidencia o comportamiento contrario a los valores de la compañía, a su normativa interna de conducta, infracción normativa o susceptible de generar responsabilidad penal. En este sentido, puedes contactar directamente con el Responsable de Cumplimiento enviando un email a la siguiente dirección de correo electrónico: <a style='text-decoration: underline;' href='mailto:canaletico@matarile.es '>canaletico@matarile.es </a> o bien, cumplimentando el siguiente formulario:"
      }
    },
    formulario: {
      nombre: "Nombre",
      apellidos: "Apellidos",
      email: "Email",
      mensaje: "Mensaje",
      asunto: "Asunto",
      medioComunicacion: "Medio de comunicación",
      he_leido: "He leído y acepto la",
      y_acepto: "política de privacidad",
      enviar: "Enviar",
      enviado: "Enviado",
      telefono: "Teléfono",
      provincia: "Provincia",
      localidad: "Localidad",
      calle: "Dirección postal (Calle, número y población)",
      cp: "Código postal",
      cv: "Adjuntar CV",
      documentation: "Adjuntar Documentación",
      fecha_nacimiento: "Fecha de nacimiento",
      publicidad:
        "Consiento el envío de comunicaciones comerciales sobre productos y servicios del grupo Risi así como el tratamiento automatizado para poder optimizar y personalizar dichas ofertas.",
      revisa: "Por favor,<br>revisa todos los campos",
      puedesEnviar: "¡Perfecto!<br>Ya lo puedes enviar :)",
      gracias: "¡Gracias por participar!<br>y mucha suerte!",
      enviado: "¡Enviado!<br>Nos pondremos en contacto lo antes posible",
      enviando: "¡Un momento!<br>Lo estamos enviando"
    },
    politica_privacidad: {
      descrip1:
        "<h3>1. ¿QUIENES SOMOS?</h3><p>APERITIVOS MATARILE S.A es una Empresa española familiar con más de cincuenta años de historia, especialistas en la fabricación y comercialización de aperitivos y galletas para terceros.</p><p>El objetivo y fin de la existencia de APERITIVOS MATARILE S.A es el de cubrir las necesidades y satisfacer las expectativas de los consumidores, basándose en marcas de la máxima calidad y procesos en mejora permanente</p>",
      descrip2:
        "<h3>2. ¿QUIÉN ES EL RESPONSABLE DEL TRATAMIENTO DE SUS DATOS PERSONALES?</h3><p>Los datos de carácter personal facilitados por usted serán tratados por APERITIVOS MATARILE S.A  (APERITIVOS MATARILE), con NIF A82922816 y domicilio social sito en Ctra. Marchena-Puebla de Cazalla, Km 1, CP 41620 Marchena (Sevilla)., y correo electrónico <a href='mailto:matarile@matarile.es' target='_blank'> matarile@matarile.es</a></p><p>Los datos de contacto de nuestro Delegado de Protección de datos:<a href='mailto:dpd.cliente@conversia.es' target='_blank'> dpd.cliente@conversia.es</a> y teléfono: <a href='tel:872987665' target='_blank'>872 98 76 65</a></p>",
      descrip3:
        "<h3>3. ÁMBITO DE APLICACIÓN.</h3><p>La presente Política de Privacidad tienen por objeto regular el tratamiento de datos que se lleva a cabo de los datos de los Usuarios de la web de APERITIVOS MATARILE.  Por tanto, se aplicará a todo aquel Usuario que navegue y utilice la web de APERITIVOS MATARILE, solicite información mediante cualquier canal habilitado al efecto (correo electrónico, teléfono, etc). Asi como también, es aplicable a los clientes, proveedores y otras figuras afines en sus relaciones con APERITIVOS MATARILE.</p><p>El Interesado declara haber leído y entendido previamente la presente Política de Privacidad, y, voluntariamente las acepta, sin reserva alguna y, exime a APERITIVOS MATARILE del mal uso que se pueda hacer de la información que se envía a través de esta.</p>",
      descrip4:
        "<h3>4. ¿DE DÓNDE OBTENEMOS SUS DATOS PERSONALES?</h3><p>Sus datos los recabamos por diferentes canales:</p><h4>4.1. Información proporcionada por usted.</h4><p>Tratamos información personal proporcionada por usted mediante los canales creados al efecto, como formulario de contacto provisto en la web y/o en nuestras oficinas, correo electrónico, teléfono, WhatsApp, o bien, interactúa con nosotros por redes sociales o comparte nuestro contenido. Asimismo, recabamos información cuando participa en sorteos o promociones, campañas de marketing, suscripciones a boletines de información, o bien en encuestas de satisfacción.</p><p>Asimismo, tratamos datos derivados del uso y funcionamiento del sistema interno de información de APERITIVOS MATARILE. Dichos datos, son aportados directamente por los interesados o, en su caso, por los informantes, trabajadores y/o terceros a los que se solicite información durante el transcurso de la investigación (si se diera el caso) y estarán en todo caso relacionados con los hechos investigados</p><p>También tratamos sus datos para cuando desee querer formar parte de nuestro equipo de APERITIVOS MATARILE al enviarnos su candidatura por correo electrónico: <a href='mailto:empleo@matarile.es' target='_blank'>empleo@matarile.es</a>.</p><h4>4.2. Información recopilada por APERITIVOS MATARILE S.A </h4><p>Nosotros y nuestros proveedores de servicios de terceros, como socios de analítica, redes sociales y publicitarias, podemos usar tecnologías que recopilan de forma automática (o pasiva) cierta información cuando un Usuario interactúa en línea en la web. Utilizamos también cookies, pero para ello, revisa nuestra <strong><a href='/politica-de-cookies' target='_blank'>“Política de Cookies”</a></strong>.</p>",
      descrip5:
        "<h3>5. ¿QUÉ TIPO DE INFORMACIÓN TRATAMOS?</h3><p>APERITIVOS MATARILE, podría tratar el siguiente tipo de información:</p></br><ul><li>Identificadores e información de contacto como nombre, dirección de correo electrónico, dirección postal, número de teléfono</li><li>Información sobre tu uso y navegación en nuestros sitios web y aplicaciones; por ejemplo, el sitio web del que provienes, las páginas web que más visita, la cantidad de veces que ve un vídeo o interactúa con una imagen.</li><li>Datos de contacto e información personal y profesional para cuando nos remita su candidatura para un puesto vacante.</li><li>	Cualquier dato derivado del uso y funcionamiento del sistema interno de información. Consistirán en información sobre los hechos de los que se informa, así como, en caso de que se proporcionen, datos identificativos, de contacto (nombre y apellidos, e-mail, teléfono), económicos, profesionales y laborales del informante y las personas sobre las que se informa. En ocasiones excepcionales, y solo si fuera necesario, se tratarán datos de categorías especiales (por ejemplo, datos relativos a infracciones penales o administrativas, datos de salud, datos sobre la orientación o vida sexual u origen étnico o racial).</li><li>Imágenes captadas por los sistemas de videovigilancia.</li></ul><p>APERITIVOS MATARILE solo procesará datos personales sensibles o confidenciales cuando sea estrictamente necesario y solo con su consentimiento previo.</p>",
      descrip6:
        "<h3>6. ¿CON QUÉ FINALIDAD Y BASE LEGAL TRATAMOS SUS DATOS PERSONALES?</h3><p>APERITIVOS MATARILE, se comprometen a tratar sus datos personales de conformidad con lo establecido en la normativa aplicable y, en particular para las siguientes finalidades:</p><ul><li><strong>Visitantes in situ. </strong>Recabaremos sus datos personales cuando visite alguna de nuestras fabricas o instalaciones “in situ”, con la finalidad de controlar los pases o visitas.</li><li><strong>Gestionar las consultas, reclamaciones, incidencias y/o sugerencias. </strong>Sus datos los trataremos con la finalidad de gestionar de manera administrativa las consultas, reclamaciones, incidencias y/o sugerencias remitidas por el canal correspondiente.</li><li><strong>Datos recabados a través de la web. </strong>La finalidad del recabado de este tipo de datos es para brindarle una mejor experiencia en el uso de la web.</li><li><strong>Gestión de candidatos. </strong>Recopilamos la información personal y profesional, que nos proporciona al correo electrónico <a href='mailto:empleo@matarile.es' target='_blank'>empleo@matarile.es</a>, para tratar a los posibles candidatos.</li></ul><p>La base legal para los tratamientos de tus datos para las finalidades anteriormente mencionadas es el consentimiento que nos ha otorgado según las finalidades específicas y en virtud de lo establecido en el art. 6.1 a) del RGPD. Sus datos personales serán conservados para esta finalidad hasta que no revoque su consentimiento.</p><ul><li><strong>Gestión de proveedores de servicios. </strong>APERITIVOS MATARILE tratará datos personales de sus proveedores con la finalidad estrictamente para la ejecución del contrato. </br>La base legal para las finalidades mencionadas anteriormente es para la ejecución de un contrato en el que el interesado es parte en virtud de lo establecido en el art. 6.1 b) del Reglamento General de Protección de Datos (en adelante “RGPD”). </li><li><strong>Gestión de datos para el cumplimiento de obligaciones de carácter legal y regulatorio.  </strong>Todos los responsables del tratamiento de datos están sometidos a las leyes de los países en los que desarrollan su actividad, y están obligados a cumplirlas. Entre estas obligaciones se incluye la entrega, en determinadas circunstancias, de datos de carácter personal a órganos judiciales, organismos reguladores o supervisores y cuerpos y fuerzas de seguridad del estado. </li><li><strong>Canal de denuncias: </strong>APERITIVOS MATARILE tratará la información recibida en el Canal de Denuncias, que contiene datos personales, de acuerdo con una obligación legal de la Ley 2/2023, de 20 de febrero, reguladora de la protección de las personas que informen sobre infracciones normativas y de lucha contra la corrupción y, con la única finalidad de procesar la comunicación y decidir sobre su admisión o inadmisión. En caso de admitir, se llevará a cabo la investigación correspondiente para adoptar las medidas disciplinarias que correspondan. En los casos de revelación pública, el tratamiento tiene como base de legitimación el cumplimiento de una misión realizada en interés público conforme al artículo 6.1.e del RGPD. Además, se solicitará el consentimiento cuando proceda para cumplir con los requisitos de la normativa. </br>Las condiciones del tratamiento de las informaciones recibidas en el Canal de Denuncias habilitado se regulan en la presente política de privacidad. </br>La base legal para los tratamientos de sus datos para las finalidades anteriormente mencionadas es el cumplimiento de obligaciones legales aplicables al responsable del tratamiento, en virtud de lo establecido en el art. 6.1 c) del RGPD. </li><li><strong>Gestión de control de calidad. </strong>Le informamos que registramos las interacciones con los consumidores, como correos electrónicos, llamadas telefónicas a la línea de ayuda de APERITIVOS MATARILE, para control de calidad. </li><li><strong>Videovigilancia. </strong>Le informamos que para garantizar la seguridad de personas, bienes e instalaciones trataremos sus datos mediante cámaras de videovigilancia.</li></ul><p>La base legal para los tratamientos de sus datos para las finalidades anteriormente mencionadas es el interés legítimo aplicables al responsable del tratamiento, en virtud de lo establecido en el art. 6.1 d) del RGPD. </p>",
      descrip7:
        "<h3>7. ¿POR CUÁNTO TIEMPO CONSERVAREMOS SUS DATOS?</h3><p>Sus datos personales serán conservados durante el tiempo necesario para cumplir las finalidades mencionadas. En todo caso, limitamos el acceso a sus datos sólo a aquellas personas que necesiten utilizarla para el desempeño de sus funciones.</p><p>El periodo de conservación de la información tratada se fundamenta en las necesidades del negocio, por lo cuando sean innecesarios, se mantendrán debidamente bloqueados con el único fin de atender las responsabilidades de cualquier índole que pudieran surgir.</p><ul><li><strong>Finalidades relacionadas con el consentimiento prestado. </strong>Se mantendrá los datos hasta que no se revoque el consentimiento por el interesado y, como máximo hasta el plazo de cuatro años desde que se recabo el consentimiento expreso.</li><li><strong>Finalidades relacionadas con la ejecución de un contrato. </strong>El periodo de conservación para la gestión de alguna obligación contractual que tengamos con usted, conservaremos esos datos durante el período de vigencia del contrato y durante los diez años siguientes, para poder atender a posibles consultas o reclamaciones posteriores.</li><li><strong>Finalidades relacionadas con el cumplimiento de obligaciones legales. </strong>Determinada información deberá mantenerse durante los plazos exigidos por la normativa específica que resulte de aplicación (fiscal, mercantil, blanqueo de capitales, etc.).</li><li><strong>Finalidades relacionadas con el interés legítimo de APERITIVOS MATARILE. </strong>Determinada información deberá mantenerse durante los plazos necesarios en cumplimiento del interés de APERITIVOS MATARILE. En relación con las imágenes y los datos de control de accesos, estos se conservaran durante un plazo máximo de un mes desde su captación o grabación, transcurrido el cual se procederá al borrado. Sin embargo, cuando se produjese la grabación de un delito o infracción administrativa que deba ser puesta en conocimiento de una autoridad, deberán conservarse las imágenes con el único fin de ponerlas a disposición de la citada autoridad sin que puedan ser utilizadas para ningún otro propósito.</li><li><strong>Finalidades relacionadas con el canal ético de APERITIVOS MATARILE. </strong>El plazo máximo de tramitación de la investigación y resolución de lascomunicaciones recibidas será de tres meses para los casos generales y paraaquellos de especial complejidad, la duración podrá prorrogarse otros tresmeses previa motivación del Responsable del Sistema Interno de Información ycon el fin de dejar evidencia del funcionamiento del sistema.</li></ul><p>En caso de que la comunicación sea admitida a trámite, los datos personales serán tratados por el tiempo necesario para llevar a cabo la investigación y cumplir con obligaciones legales. Una vez concluida la investigación, los datos personales serán conservados por el tiempo necesario para adoptar y ejecutar las medidas que correspondan y, tras ello, por el plazo máximo de prescripción de cualesquiera acciones legales o contractuales. En ningún caso se conservarán los datos por un período superior a diez años. Si se acreditara que la información facilitada o parte de ella no es veraz, se procederá a su inmediata supresión desde el momento en que se tenga constancia de dicha circunstancia, salvo que dicha falta de veracidad pueda constituir un ilícito penal, en cuyo caso se guardará la información por el tiempo necesario durante el que se tramite el correspondiente procedimiento judicial.</p><p>Aquellas <strong>denuncias orales,</strong> deberán quedar documentadas, previo consentimiento del informante, a través de una grabación en un formato duradero, seguro y accesible, o de una transcripción completa y exacta, en cuyo caso se ofrecerá al informante la oportunidad de comprobar, rectificar y aceptar mediante su firma la transcripción de la conversación. A estos efectos, se entiende que, al formular la comunicación verbalmente, el informante acepta y es consciente de que la misma será documentada por alguna de las vías anteriores.</p>",
      descrip8:
        "<h3>8. ¿A QUÉ DESTINATARIOS SE COMUNICARÁN SUS DATOS PERSONALES?</h3><p>Sus datos no se comunicarán a terceros, salvo autorización expresa o bien, en los casos legalmente admisibles, se facilitará información a las Autoridades Públicas como: a las Autoridades Tributarias, para el cumplimiento de obligaciones fiscales; a las Administraciones competentes, Fuerzas y Cuerpos de Seguridad del Estado Jueces y Tribunales y a la Agencia Española de Protección de Datos, en cumplimiento de obligaciones legales de los Responsables del Tratamiento o para el caso de conflictos relacionados con derechos de los consumidores, derecho de protección de datos, derecho de propiedad intelectual o industrial, o con cualesquiera otros bienes y/o derechos protegidos.  Así como, como a entidades financieras para la gestión de cobros y pagos.</p><p>Del mismo modo, algunas entidades subcontratadas por APERITIVOS MATARILE podrían acceder a los datos personales e información como encargados o sub encargados del tratamiento para prestarnos el servicio necesario. Estos proveedores de servicios firman un contrato que les obliga a utilizar su información personal únicamente para la prestación de los servicios informados en esta política.  Esto incluye a terceros que nos permiten responder a sus consultas, call center, brindar servicios al consumidor, participar en nuestras promociones, alojar nuestros sitios web, entregar comunicaciones de marketing y analizar información.</p><p>En relación al Canal de Denuncias, los datos serán tratados por la persona responsable del mismo y sólo, serán comunicados a terceros cuando sea apropiado para llevar a cabo la investigación o para la posterior adopción de las medidas correctivas correspondientes (por ejemplo, el responsable de RRHH cuando proceda adoptar medidas disciplinarias contra un trabajador, o el responsable de servicios jurídicos si procediera adoptar medidas legales en relación con los hechos relatados).</p>",
      descrip9:
        "<h3>9. MEDIDAS DE SEGURIDAD DE LA INFORMACIÓN.</h3><p>APERITIVOS MATARILE, garantiza el buen uso de la información, y en especial, la plena confidencialidad de los datos de carácter personal contenidos en nuestro sistema, así como el pleno cumplimiento de las obligaciones en materia de protección de datos de carácter personal.</p><p>APERITIVOS MATARILE tiene implantadas las medidas de seguridad de índole técnica y organizativas necesarias para garantizar la seguridad de sus datos de carácter personal y evitar su alteración, pérdida y tratamiento y/o acceso no autorizado, habida cuenta del estado de la tecnología, de la naturaleza de los datos almacenados y de los riesgos a que están expuestos, ya provengan de la acción humana o del medio físico o natural.</p>",
      descrip10:
        "<h3>10. ¿CUÁLES SON SUS DERECHOS CUANDO NOS FACILITA INFORMACIÓN PERSONAL?</h3><p>Le informamos que, en cualquier momento, puede ejercer sus derechos de acceso, rectificación, oposición, supresión, portabilidad, no ser objeto de decisiones automatizadas y limitación del tratamiento ante APERITIVOS MATARILE.</p><h4>10.1 ¿En qué consisten tus derechos como Interesado?</h4><ul><li>Derecho de acceso: tienes derecho a obtener confirmación sobre si RISI trata sus datos personales, así como a acceder a los mismos.</li><li>Derecho de rectificación: podrá solicitar la modificación o rectificación de los datos personales que sean inexactos.</li><li>Derecho de supresión: podrá solicitar la supresión de sus datos personales.</li><li>Derecho de limitación del tratamiento: En determinadas circunstancias, podrá solicitar la limitación del tratamiento de sus datos, en cuyo caso únicamente se conservarán para el ejercicio o la defensa de reclamaciones.</li><li>Derecho de oposición: podrá oponerse al tratamiento de sus datos para la finalidad que especifique.</li><li>Derecho a no ser objeto de decisiones individuales automatizadas: tiene derecho a no ser objecto de una decisión basada únicamente en el tratamiento automatizado, incluida la elaboración de perfiles, que pueda producir efectos jurídicos o le afecte significativamente de modo similar.</li><li>Derecho de portabilidad: si la web lo permite, podrá ejercer el derecho a la portabilidad de sus datos, en un formato estructurado, de uso común y lectura mecánica, y a transmitirlos a otro responsable del tratamiento.</li></ul><h4>10.2 ¿Cómo ejerzo mis derechos?</h4><p>Puede ejercitar estos derechos dirigiéndose a través de correo electrónico a:<a href='matarile@matarile.es' target='_blank'>matarile@matarile.es</a> o bien, a nuestro Delegado de Protección de Datos: <a href='dpd.cliente@conversia.es' target='_blank'>dpd.cliente@conversia.es</a></p><p>Más información disponible sobre sus derechos en la página web de la Agencia Española de Protección de Datos, <a href='https://www.aepd.es/es' target='_blank'>https://www.aepd.es/es </a></p><p>El ejercicio de sus derechos será totalmente gratuito.</p><p><strong>En cualquiera caso, deberá hacer la solicitud indicando el ejercicio del derecho y el canal por el cual se desea recibir la respuesta. </strong></p><p>Finalmente, si considera que no ha obtenido satisfacción en el ejercicio de sus derechos o no está conforme con el tratamiento llevado a cabo de sus datos personales, puede presentar una reclamación ante la Autoridad de Control Competente (<a href='https://www.ctpdandalucia.es/sites/default/files/inline-files/boja23-resolucion_plan_inspeccion_proteccion_datos.pdf' target='_blank'>Consejo de Transparencia y Protección de Datos de Andalucía</a>.)</p>",
      descrip11:
        "<h3>11. MODIFICACIONES.</h3><p>Nos reservamos el derecho a modificar la presente Política para adaptarla a novedades legislativas o jurisprudenciales. En caso de que se produzcan cambios en la misma APERITIVOS MATARILE S informará oportunamente.</p></br><p><strong>ÚLTIMA ACTUALIZACIÓN: Diciembre de 2024.</strong></p>"
    }
  },
  en: {
    enlaces: {
      noticias: "/news",
      sala_de_prensa: "/press-room",
      contacto: "/contact",
      trabaja_con_nosotros: "/work-with-us",
      politica_privacidad: "/privacy-policy",
      politica_cookies: "/cookies-policy",
      ethical_chanel: "/ethical-chanel",
      pressroom: "/pressroom"
    }
  }
};



// WEBPACK FOOTER //
// ./src/translations/index.js